(function ($) {
  var body = $('body');
      
    var wishListsArr = localStorage.getItem('wishListsArr') ? JSON.parse(localStorage.getItem('wishListsArr')) : [];
    localStorage.setItem('wishListsArr', JSON.stringify(wishListsArr));
    if (wishListsArr.length) {
        wishListsArr = JSON.parse(localStorage.getItem('wishListsArr'));
    };

  
    $(document).ready(function () {
        $(document).ajaxStart(function () {
            nuranium.isAjaxLoading = !0
        });

        $(document).ajaxStop(function () {
            nuranium.isAjaxLoading = !1
        });
        nuranium.init();
        $('#popup-subscribe i.zmdi-close').on('click', function() {
            $(this).parents('#popup-subscribe').modal('hide');
        })
        var t = {
            shop: vinovathemes.main_info.shop,
            purchase_code: vinovathemes.main_info.lic,
            shopify_domain: vinovathemes.main_info.domain,
            'status': vinovathemes.main_info.status
        };
        nuranium.validLicense(t)
    });
  
    var nuranium = {
        validLicense: function(t) {
            $.ajax({
                url: "https://vinovathemes.com/license/check_license.php",
                type: "post",
                data: t,
                success: function(t) {
                    var a = JSON.parse(t);
                    if ($("#Nov_purchasecode").on("contextmenu", function(t) {
                            t.preventDefault()
                        }), !1 == a.status) return $("#Nov_purchasecode").removeClass("hide hidden"), $("#Nov_purchasecode-waring").html(a.msg), !1;
                    a.status && ($("#Nov_purchasecode-waring").html(a.msg).slideDown(250),
                    setTimeout(function() {
                        $("#Nov_purchasecode").remove()
                    }, 1e3))
                }
            })
        },
        isAjaxLoading: !1,
        init: function () {
            this.closeModal();
            this.novProductTabs();

            this.initNovWishListIcons();
            this.doAddOrRemoveWishlistProduct();
            this.doAddOrRemoveWishlist();

            if($('body').hasClass('template-page') && $('.wishlist-page').length) {
            this.initNovWishListsPage();
            };
            this.ajaxProductAddToCart();
            this.ajaxAddToCart();
            this.ajaxChangeFromCart();
            this.initMiniCart();
            
            this.ajaxRemoveFromCart();
            this.changeQuantityPageCart();
            this.initCollapseSidebarBlock();
            this.changeQuantityMiniCart();
            this.initproductItemColorSwatch();
            this.productItemSwatch();
            this.togglePopupAddToCart();
            if(body.hasClass('template-collection')) {
              this.initCollectionPageLoadmore();
            }
            if ($(window).width() > 767) {
                this.initQuickView();
            }
        },
        initCollectionPageLoadmore: function () {
          var scroll__infitiny = $('.scroll__infitiny');
          var infiniteScrolling_url = '.scroll__infitiny a';
          if (scroll__infitiny.length) {
            body.off('click.initCollectionPageLoadmore', infiniteScrolling_url).on('click.initCollectionPageLoadmore', infiniteScrolling_url, function (e) {
                e.preventDefault();
                e.stopPropagation();
                if (!$(this).hasClass('disabled')) {
                    var url = $(this).data('href');
                    nuranium.ajaxCollectionPageLoadmoreGetContent(url);
                };
            });

            $(window).scroll(function () {
              if (nuranium.isAjaxLoading) return;
              var collectionContent = $('.collection-filter__content');
              var collectionTop = collectionContent.offset().top;
              var collectionHeight = collectionContent.outerHeight();
              var posTop = collectionTop + collectionHeight - $(window).height();
              if ($(this).scrollTop() > posTop && $(this).scrollTop() < (posTop + 200)) {
                  var button = $(infiniteScrolling_url);
                  if (button.length && !button.hasClass('disabled')) {
                      var url = button.data('href');
                      nuranium.ajaxCollectionPageLoadmoreGetContent(url);
                  };
              };
          });
          }
        },
        ajaxCollectionPageLoadmoreGetContent: function (url) {
          if (nuranium.isAjaxLoading) return;
          $.ajax({
            type: "GET",
            url: url,
            beforeSend: function () {
              $('.scroll__infitiny').removeClass('loading').addClass('loading');
            },
            success: function (data) {
              nuranium.ajaxCollectionPageLoadmoreMapData(data);
              if ($('.jdgm-widget').length) {
                jdgm.customizeBadges()
              }
            },
            complete: function () {
              $('.scroll__infitiny').removeClass('loading');
            }
          });
        },
        ajaxCollectionPageLoadmoreMapData: function (data) {
          var collectionTemplate = $('.collection-template');
          var currentProductCollection = collectionTemplate.find('.product-collection');
          var currentProductCount = collectionTemplate.find('.paging');
          var newCollectionTemplate = $(data).find('.collection-template');
          newProductCollection = newCollectionTemplate.find('.product-collection');
          newProductCount = newCollectionTemplate.find('.paging');
          newProductItem = newProductCollection.children('.product--item');
          currentProductCount.replaceWith(newProductCount);
          if (newProductCollection.length) {
            currentProductCollection.append(newProductItem);

            var n = collectionTemplate.find('.product--item').length;
            var m = $('.pagination__bar').data('max');
            $('.pagination__count .count').text(n);
            $('.pagination__bar .progress').css('width',  n/m*100 + '%');
          }
        },
        togglePopupAddToCart: function() {
            $('.selector-wrapper-1').each(function(){
              if ($(this).hasClass('opt-color.hide')) {
                $(this).closest('.item-product__popup--variant').find('.btn-close-quick-add').hide();
              }
            })
            $(document).on('click', '.btn-quick-add', function(){
                $('.item-product__popup--variant').removeClass('act');
                $('.item-product .thumbnail-container').removeClass('popup-act');
                $(this).parent().find('.item-product__popup--variant').addClass('act');
                $(this).parents('.thumbnail-container').addClass('popup-act');
                if ($(this).parents('.nov-slick-carousel').data('nav') == true) {
                    $(this).parents('.nov-slick-carousel').find('.slick-arrow').css('visibility', 'hidden')
                }
                if ($(this).parents('.collection-carousel').data('nav') == true) {
                    $(this).parents('.collection-carousel').find('.slick-arrow').css('visibility', 'hidden')
                }
                $(this).parents('.item-product').find('.countdownfree').css('visibility','hidden');
            });
            $(document).on('click', '.btn-close-quick-add', function(){
                $(this).parent().removeClass('act');
                $(this).parents('.thumbnail-container').removeClass('popup-act');
                if ($(this).parents('.nov-slick-carousel').data('nav') == true) {
                    $(this).parents('.nov-slick-carousel').find('.slick-arrow').css('visibility', 'visible')
                }
                if ($(this).parents('.collection-carousel').data('nav') == true) {
                    $(this).parents('.collection-carousel').find('.slick-arrow').css('visibility', 'visible')
                }
                $(this).parents('.item-product').find('.countdownfree').css('visibility','visible');
            });
            /*$(document).on("click", function(event){
                if(!$(event.target).closest(".inner-top").length){
                    $(".item-product__popup--variant").removeClass('act');
                }
            });*/
        },
        initCollapseSidebarBlock: function() {
            $(document).on("click", ".facets__label--title", t => {
                var a = $(t.currentTarget),
                    o = a.parents('.js-filter').find(".facets__content");
                a.parent().hasClass("act") ? (a.parent().removeClass("act"), a.parents('.js-filter').removeClass("act"), 
                o.slideUp()) : (a.parent().addClass("act"), a.parents('.js-filter').addClass("act"), o.slideDown())
            })
        },
        closeModal: function() {
            $('.close-modal, .overlay').click(function() {
                $('.loading-modal').css({"opacity": "0", "visibility": "hidden", "transform": "translateX(410px)", "transition": "all 0.3s"});
            });
        },

        novProductTabs: function () {
            var productTabs = $('[data-product-tabs]');
            productTabs.each(function () {
                var self = $(this),
                    listTabs = self.find('.list-product-tabs'),
                    tabLink = listTabs.find('[data-product-tabtop]'),
                    tabContent = self.find('[data-product-TabContent]'),
                    linkActive = self.find('.list-product-tabs .tab-links.active'),
                    activeTab = self.find('.product-tabs-content .tab-content.active');

                nuranium.doAjaxNovProductTabs(linkActive.data('href'), activeTab.find('.products-grid'), tabLink);
                tabLink.off('click').on('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    if ($(this).hasClass('active')) {
                        return;
                    }
                    if (!$(this).hasClass('active')) {
                        var curTab = $(this),
                            curTabContent = $(curTab.data('target'));
                        tabLink.removeClass('active');
                        tabContent.removeClass('active');
                        if (!curTabContent.find('.collection-carousel').hasClass('slick-initialized')) {
                            nuranium.doAjaxNovProductTabs(curTab.data('href'), curTabContent.find('.products-grid'), tabLink);
                        }
                        curTab.addClass('active');
                        curTabContent.addClass('active');
                        if (curTabContent.find('.collection-carousel').hasClass('slick-initialized')) {
                            var productGrid = $(curTabContent.find('.collection-carousel'));
                            var num = productGrid.find('.slick-slide').length,
                                num_act = productGrid.find('.slick-active').length,
                                num_first = productGrid.find('.slick-active:first').data('slick-index'),
                                num_last = productGrid.find('.slick-active:last').data('slick-index') + 1,
                                prev = productGrid.parents('[data-product-tabs]').find('.nav-slider--prev'),
                                next = productGrid.parents('[data-product-tabs]').find('.nav-slider--next'),
                                currentSlide = productGrid.find('.slick-current').data('slick-index');
                                productGrid.parents('[data-product-tabs]').find('.total_nav').text(Math.ceil(num / num_act));
                                page = Math.ceil(((currentSlide || 0) + 1) / length);
                                if (page > Math.ceil(num / num_act)) {
                                    page = Math.ceil(num / num_act)
                                }
                                productGrid.parents('[data-product-tabs]').find('.current_nav').text(page);
                            if (num == num_act) {
                                prev.css('visibility', 'hidden');
                                next.css('visibility', 'hidden');
                            } else {
                                prev.css('visibility', 'visible');
                                next.css('visibility', 'visible');
                            }
                            if(num_first == 0) {
                                prev.addClass('disabled');
                            } else {
                                prev.removeClass('disabled');
                            }
                            if (num - num_last > 0 ) {
                                next.removeClass('disabled');
                            } else {
                                next.addClass('disabled');
                            }
                        }
                    }
                });
            });
        },

        doAjaxNovProductTabs: function(handle, curTabContent, tabLink) {
            $.ajax({
                type: "GET",
                url: window.router + handle,
                beforeSend : function (){
                    tabLink.css({'pointer-events': 'none', 'opacity': '0.6'});
                },
                success: function (data) {
                    if (handle == '/collections/?view=json' || handle == '/collections/?view=new-json') { 
                    } else {
                        curTabContent.html($(data).find('.grid-item').html());
                        var limit = tabLink.data('limit') - 1;
                        curTabContent.find('.block:gt('+ limit +')').remove();
                        if (curTabContent.hasClass('collection-carousel')) {
                            if (!curTabContent.hasClass('slick-initialized')) {
                                nuranium.initNovProductTabsSlider(curTabContent.parent());
                            };
                        }
                        nuranium.initNovWishListIcons();
                        setTimeout(function () {
                            if ($('.shopify-product-reviews-badge').length && $('.spr-badge').length) {
                                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                            };
                        }, 500);
                    };
                },
                complete: function() {
                    tabLink.css({'pointer-events': 'auto', 'opacity': '1'});
                }
            });
        },
        
        initNovProductTabsSlider: function (tabslider) {
            tabslider.each(function () {
                var self = $(this),
                    productGrid = self.find('.products-grid'),
                    t = !!$("html").hasClass("lang-rtl");
                
                if (productGrid.not('.slick-initialized')) {
                    productGrid.on('init reInit afterChange', function(event, slick, currentSlide) {
                        const
                            length = productGrid.find('.slick-active').length,
                            page = Math.ceil(((currentSlide || 0) + 1) / length),
                            numPages = Math.ceil(slick.slideCount / length);
                            self.parents('[data-product-tabs]').find('.current_nav').text(`${page}`);
                            self.parents('[data-product-tabs]').find('.total_nav').text(`${numPages}`);
                            self.parents('[data-product-tabs]').find('.num_nav').css('opacity', '1');
                    });
                    productGrid.slick({
                        nextArrow: '<div class="arrow-next"><i class="rbb-icon-direction-39"></i></div>',
                        prevArrow: '<div class="arrow-prev"><i class="rbb-icon-direction-36"></i></div>',
                        rtl: t,
                        slidesToShow: productGrid.data("items_xxl"),
                        slidesToScroll: productGrid.data("items_xxl"),
                        rows: productGrid.data("row"),
                        row_mobile: productGrid.data("row_mobile"),
                        arrows: productGrid.data("nav"),
                        dots: productGrid.data("dots"),
                        infinite: productGrid.data("loop"),
                        adaptiveHeight: !0,
                        responsive: [
                            { 
                                breakpoint: 1440, 
                                settings: { 
                                    slidesToShow: productGrid.data("items"),
                                    slidesToScroll: productGrid.data("items"),
                                }
                            },
                            { 
                                breakpoint: 1200, 
                                settings: { 
                                    slidesToShow: productGrid.data("items_lg"), 
                                    slidesToScroll: productGrid.data("items_lg"),
                                    arrows: false
                                } 
                            },
                            { 
                                breakpoint: 992, 
                                settings: { 
                                    slidesToShow: productGrid.data("items_md"), 
                                    slidesToScroll: productGrid.data("items_md"),
                                    arrows: false
                                } 
                            },
                            { 
                                breakpoint: 768, 
                                settings: { 
                                    slidesToShow: productGrid.data("items_sm"), 
                                    slidesToScroll: productGrid.data("items_sm"),
                                    arrows: false,
                                } 
                            },
                            { 
                                breakpoint: 480, 
                                settings: { 
                                    slidesToShow: productGrid.data("items_xs"), 
                                    slidesToScroll: productGrid.data("items_xs"),
                                    arrows: !1,
                                    rows: productGrid.data("row_mobile")
                                } 
                            },
                        ]
                    });
                    var currentSlide = productGrid.slick('slickCurrentSlide');
                    checkArrow(this, currentSlide);

                    $(this).on('afterChange', function(event, slick, currentSlide, nextSlide){
                        checkArrow(this, currentSlide);
                    });
                    function checkArrow(el, current) {
                        var num = $(el).find('.slick-slide').length,
                            num_act = $(el).find('.slick-active').length,
                            prev = $(el).parents('[data-product-tabs]').find('.nav-slider--prev'),
                            next = $(el).parents('[data-product-tabs]').find('.nav-slider--next');
                        if (num - num_act == 0) {
                            prev.css('visibility', 'hidden');
                            next.css('visibility', 'hidden');
                        } else {
                            prev.css('visibility', 'visible');
                            next.css('visibility', 'visible');
                        }
                        if(current == 0) {
                            prev.addClass('disabled');
                        } else {
                            prev.removeClass('disabled');
                        }
                        if (num - num_act <= current) {
                            next.addClass('disabled');
                        } else {
                            next.removeClass('disabled');
                        }
                    };
                    $('[data-product-tabs]').find('.nav-slider--prev').click(function(){
                       $(this).parents('[data-product-tabs]').find('.tab-content.active').find(productGrid).slick('slickPrev');
                    });
                    $('[data-product-tabs]').find('.nav-slider--next').click(function(){
                       $(this).parents('[data-product-tabs]').find('.tab-content.active').find(productGrid).slick('slickNext');
                    })
                }
            });
        },
        productItemSwatch: function() {
            $(document).on('change', '.selector-wrapper :radio', function(e){ 
                var _self = $(this);
                var product_item = _self.parents('.item-product');
                var item_swatch = _self.parents('.product__popup-swatch');
                var product_info = product_item.data('json-product');
                var variants = product_info.variants;
                var option_position = product_item.find('.opt-color').data('opt-position');
                var option_index = _self.closest('[data-option-index]').data('option-index');
                var el_swatch = item_swatch.find('.swatch-element');
                var variant_value = _self.val();
                var selected_variant;
                var productInput = item_swatch.find('[name=id]');
                var selected_swatch_opt1 = item_swatch.find('.selector-wrapper-1').find('input:checked').val();
                var selected_swatch_opt2 = item_swatch.find('.selector-wrapper-2').find('input:checked').val();
                var selected_swatch_opt3 = item_swatch.find('.selector-wrapper-3').find('input:checked').val();
                el_swatch.removeClass('soldout');
                el_swatch.find(':radio').prop('disabled',false);
                switch (option_index){
                  case 0:
                      var available_variants = variants.find(function(variant){
                          if (option_position == 1) {
                              return variant.option2 == variant_value && variant.option1 == selected_swatch_opt2;
                          } else {
                            if (option_position == 2) {
                              return variant.option3 == variant_value && variant.option1 == selected_swatch_opt2;
                            } else {
                              return variant.option1 == variant_value && variant.option2 == selected_swatch_opt2;
                            }
                          }
                      })

                      if(available_variants != undefined){
                          selected_variant =  available_variants;
                      }else{
                          var alt_available_variants = variants.find(function(variant){
                              if (option_position == 1) {
                                  return variant.option2 == variant_value;
                              } else {
                                  if (option_position == 2) {
                                    return variant.option3 == variant_value;
                                  } else {
                                    return variant.option1 == variant_value;
                                  }
                              }
                          })
                          selected_variant =  alt_available_variants;
                      };
                      break;
                  case 1:
                      var available_variants = variants.find(function(variant){
                          if (option_position == 1) {
                              return variant.option2 == selected_swatch_opt1 && variant.option1 == variant_value && variant.option3 == selected_swatch_opt3;
                          } else {
                              if (option_position == 2) {
                                return variant.option3 == selected_swatch_opt1 && variant.option1 == variant_value && variant.option2 == selected_swatch_opt3;
                              } else {
                                return variant.option1 == selected_swatch_opt1 && variant.option2 == variant_value && variant.option3 == selected_swatch_opt3;
                              }
                          }
                          
                      })
                      if(available_variants != undefined){
                          selected_variant =  available_variants;
                      } else {
                          var alt_available_variants = variants.find(function(variant){
                              if (option_position == 1) {
                              return variant.option2 == selected_swatch_opt1 && variant.option1 == variant_value;
                          } else {
                              if (option_position == 2) {
                                return variant.option3 == selected_swatch_opt1 && variant.option1 == variant_value;
                              } else {
                                return variant.option1 == selected_swatch_opt1 && variant.option2 == variant_value;
                              }
                          }
                          })
                          selected_variant =  alt_available_variants;
                      };
                      break;
                  case 2:
                      var available_variants = variants.find(function(variant){
                          if (option_position == 1) {
                              return variant.option2 == selected_swatch_opt1 && variant.option1 == selected_swatch_opt2 && variant.option3 == variant_value;
                          } else {
                              if (option_position == 2) {
                                return variant.option3 == selected_swatch_opt1 && variant.option1 == selected_swatch_opt2 && variant.option2 == variant_value;
                              } else {
                                return variant.option1 == selected_swatch_opt1 && variant.option2 == selected_swatch_opt2 && variant.option3 == variant_value;
                              }
                              
                          }
                      })
                      if(available_variants != undefined){
                         selected_variant =  available_variants;
                      }
                      break;
                }
                if (selected_variant == undefined) return;
                productInput.val(selected_variant.id);
                if (selected_variant.compare_at_price > selected_variant.price) {
                    product_item.find('[data-compare-price-grid]').html(Shopify.formatMoney(selected_variant.compare_at_price, theme.moneyFormat));
                } else {
                    product_item.find('[data-compare-price-grid]').html('');
                }
                product_item.find('[data-price-grid]').html(Shopify.formatMoney(selected_variant.price, theme.moneyFormat));
                _self.parents('.selector-wrapper').find('.form-label span').text(variant_value);
                nuranium.checkStatusSwatch(product_item, item_swatch);

                var current_variant_id = item_swatch.find('.current_variant_id').attr('value');
                var inventory_policy = item_swatch.find('.product-form__variants [value="'+current_variant_id+'"]').data('inventory_policy');
                if(inventory_policy == 'continue') {
                  item_swatch.find('[data-btn-] .add-to-cart-text').text(window.inventory_text.preorder);
                } else {
                  item_swatch.find('[data-btn-addtocart] .add-to-cart-text').text(window.inventory_text.add_to_cart);
                }
            });
            $(document).on('change', '.item-product__popup--variant select.single-option-selector', function(){
                var _self = $(this);
                var product_item = _self.parents('.item-product');
                var item_swatch = _self.parents('.product__popup-swatch');
                var product_info = product_item.data('json-product');
                var variants = product_info.variants;
                var option_index = _self.data('option');
                var pval = _self.val();
                var selected_variant;
                var productInput = item_swatch.find('[name=id]');
                var selected_swatch_opt1 = item_swatch.find('[data-option="option1"]').val();
                var selected_swatch_opt2 = item_swatch.find('[data-option="option2"]').val();
                var selected_swatch_opt3 = item_swatch.find('[data-option="option3"]').val();
                switch (option_index){
                    case 'option1':
                        var available_variants = variants.find(function(variant){
                            return variant.option1 == pval && variant.option2 == selected_swatch_opt2 && variant.available;
                        })
                        if(available_variants != undefined){
                            selected_variant =  available_variants;
                        }else{
                            var altAvailableVariants = variants.find(function(variant){
                                return variant.option1 == pval && variant.available;
                            })
                            selected_variant =  altAvailableVariants;
                        };
                        break;
                    case 'option2':
                        var available_variants = variants.find(function(variant){
                            return variant.option1 == selected_swatch_opt1 && variant.option2 == pval && variant.available;
                        })
                        if(available_variants != undefined){
                            selected_variant =  available_variants;
                        };
                        break;
                    case 'option3':
                        var available_variants = variants.find(function(variant){
                            return variant.option1 == selected_swatch_opt1 && variant.option2 == selected_swatch_opt2 && variant.option3 == pval && variant.available;
                        })
                        if(available_variants != undefined){
                           selected_variant =  available_variants;
                        };
                        break;
                }
                if (selected_variant != undefined) {
                    productInput.val(selected_variant.id);
                }
                _self.parents('.selector-wrapper').find('.form-label span').text(pval);

                nuranium.checkStatusSwatch(product_item, item_swatch);
                var current_variant_id = item_swatch.find('.current_variant_id').attr('value');
                var inventory_policy = item_swatch.find('.product-form__variants [value="'+current_variant_id+'"]').data('inventory_policy');
                if(inventory_policy == 'continue') {
                  item_swatch.find('[data-btn-addtocart] .add-to-cart-text').text(window.inventory_text.preorder);
                } else {
                  item_swatch.find('[data-btn-addtocart] .add-to-cart-text').text(window.inventory_text.add_to_cart);
                }
            })
            $(document).on('click', '.selector-wrapper .unavailable :radio', function(e){
                var _self = $(this);
                _self.parents('.item-product').find('[data-btn-addtocart]').attr('disabled', 'disabled');
            });
        },
        initproductItemColorSwatch: function() {
            var item_swatch_el = '.item-swatch li label';
            body.off('click.toggleClass').on('click.toggleClass', item_swatch_el, function () {
                var self = $(this);
                var title = self.attr('data-title').replace(/^\s+|\s+$/g, '');
                var product_item = self.closest('.item');

                self.parents('.item-swatch').find('li label').removeClass('active');
                self.addClass('active');
                var product_info = $(this).parents('.item-product').data('json-product');

                var href = product_item.find('a').attr('href');
                product_item.find('.product__label-color').find('[data-change-title]').text(title)
                if (self.data('with-one-option') != undefined) {
                    var quantity = self.data('quantity');
                    var inventory_policy = self.data('inventory_policy');
                    product_item.find('[name="id"]').val(self.data('with-one-option'));
                    if (quantity > 0) {
                        product_item.find('[data-btn-addtocart]').removeClass('disabled').removeAttr('disabled');
                        if (inventory_policy == 'continue') {
                            product_item.find('[data-btn-addtocart] .add-to-cart-text').text(window.inventory_text.preorder);
                        } else {
                            product_item.find('[data-btn-addtocart] .add-to-cart-text').text(window.inventory_text.add_to_cart);
                        }
                    } else {
                        product_item.find('[data-btn-addtocart]').addClass('disabled').attr('disabled', 'disabled');
                        product_item.find('[data-btn-addtocart] .add-to-cart-text').text(window.inventory_text.sold_out);
                    }
                    var price = self.data('price'),
                        comparePrice = self.data('compare_at_price');
                    if (comparePrice > price) {
                        product_item.find('[data-compare-price-grid]').html(Shopify.formatMoney(comparePrice, theme.moneyFormat));
                    } else {
                        product_item.find('[data-compare-price-grid]').html('');
                    }
                    product_item.find('[data-price-grid]').html(Shopify.formatMoney(price, theme.moneyFormat));
                } else {
                    if (product_info != undefined) {
                        nuranium.checkStatusSwatch(self.parents('.item-product'));
                    }
                    if ($('.template-collection').length) {
                        if (self.parents('.product-collection').hasClass('products-list')) {
                            product_item.find('.product-details').find('[data-value="' + title + '"]').find('label').trigger('click');
                    } else {
                        product_item.find('.product__popup-swatch:eq(0)').find('[data-value="' + title + '"]').find('label').trigger('click');
                    }
                    }
                    else {
                        product_item.find('[data-value="' + title + '"]').find('label').trigger('click');
                    }
                }

                var new_image = self.data('img');
                if (new_image) {
                    product_item.find('.thumbnail-container .product__thumbnail, .thumbnail-container .product__thumbnail-second').attr({
                        "data-srcset": new_image,
                        "data-src": new_image,
                        "src": new_image,
                        "srcset": new_image
                    });
                    return false;
                }
                });

                body.off('click.showmore').on('click.showmore', '.item-swatch-more .show_more', function (e) {
                e.preventDefault();
                e.stopPropagation();
                $(this).parents('.item-swatch').toggleClass('show--more');
                ($(this).parents('.item-swatch').hasClass('show--more')) ? $(this).children().text('-') : $(this).children().text('+');
            });
        },
        checkStatusSwatch: function(product_item, item_swatch) {
          if (window.use_color_swatch) {
            var product_info = product_item.data('json-product');
            var variants = product_info.variants;
            var options = product_item.find('[data-option-index]');
            var opt_position = product_item.find('.opt-color').data('opt-position');
            if (item_swatch == undefined) {
                item_swatch = product_item;
            }
            var selected_swatch_opt1 = item_swatch.find('[data-option-index="0"]').find('input:checked').val();
            var selected_swatch_opt2 = item_swatch.find('[data-option-index="1"]').find('input:checked').val();
            var selected_swatch_opt3 = item_swatch.find('[data-option-index="2"]').find('input:checked').val();

            options.each(function(){
              var option_index = $(this).data('option-index');
              var item_el = $(this).find('.swatch-element');
              switch (option_index) {
                  case 0:
                  item_el.each(function(){
                      var swatch_val = $(this).data('value');
                      var opt1_soldout = variants.find(function(variant){
                          if (opt_position == 1) {
                              return variant.option2 == swatch_val && variant.available;
                          } else {
                              if (opt_position == 2) {
                                return variant.option3 == swatch_val && variant.available;
                              } else {
                                return variant.option1 == swatch_val && variant.available;
                              }  
                          }
                      });
                      var option_unavailable = variants.find(function(variant){
                          if (opt_position == 1) {
                              return variant.option2 == swatch_val;
                          } else {
                              if (opt_position == 2) {
                                return variant.option3 == swatch_val;
                              } else {
                                return variant.option1 == swatch_val;
                              }
                          }
                      });
                      if(opt1_soldout == undefined){
                          if (option_unavailable == undefined) {
                            $(this).addClass('unavailable');
                            $(this).removeClass('soldout');
                            $(this).removeClass('available');
                            $(this).find(':radio').prop('checked',false);
                            $(this).attr('data-toggle', 'modal');
                            $(this).attr('data-target', '#Form_newletter');
                          } else {
                            $(this).addClass('soldout');
                            $(this).removeClass('unavailable');
                            $(this).removeClass('available');
                            $(this).find(':radio').prop('disabled',false);
                            $(this).attr('data-toggle', 'modal');
                            $(this).attr('data-target', '#Form_newletter');
                          }
                      } else {
                            $(this).removeClass('soldout');
                            $(this).removeClass('unavailable');
                            $(this).addClass('available');
                            $(this).find(':radio').prop('disabled',false);
                            $(this).removeAttr('data-toggle', 'modal');
                            $(this).removeAttr('data-target', '#Form_newletter');                        
                      }
                  })
                  break;
                  case 1:
                  item_el.each(function(){
                      var swatch_val = $(this).data('value');
                      var opt1_soldout = variants.find(function(variant){
                          if (opt_position == 1) {
                              return variant.option2 == selected_swatch_opt1 && variant.option1 == swatch_val && variant.available;
                          } else {
                              if (opt_position == 2) {
                                return variant.option3 == selected_swatch_opt1 && variant.option1 == swatch_val && variant.available;
                              } else {
                                return variant.option1 == selected_swatch_opt1 && variant.option2 == swatch_val && variant.available;
                              }
                          }
                      });
                      var option_unavailable = variants.find(function(variant){
                          if (opt_position == 1) {
                              return variant.option2 == selected_swatch_opt1 && variant.option1 == swatch_val;
                          } else {
                              if (opt_position == 2) {
                                return variant.option3 == selected_swatch_opt1 && variant.option1 == swatch_val;
                              } else {
                                return variant.option1 == selected_swatch_opt1 && variant.option2 == swatch_val;
                              }
                          }
                      });
                      if(opt1_soldout == undefined){
                          if (option_unavailable == undefined) {
                              $(this).addClass('unavailable');
                              $(this).removeClass('soldout');
                              $(this).removeClass('available');
                              $(this).find(':radio').prop('checked',false);
                              $(this).attr('data-toggle', 'modal');
                              $(this).attr('data-target', '#Form_newletter');
                          } else {
                              $(this).addClass('soldout');
                              $(this).removeClass('unavailable');
                              $(this).removeClass('available');
                              $(this).find(':radio').prop('disabled',false);
                              $(this).attr('data-toggle', 'modal');
                              $(this).attr('data-target', '#Form_newletter');
                          }
                      } else {
                          $(this).removeClass('soldout');
                          $(this).removeClass('unavailable');
                          $(this).addClass('available');
                          $(this).find(':radio').prop('disabled',false);
                          $(this).removeAttr('data-toggle', 'modal');
                          $(this).removeAttr('data-target', '#Form_newletter');
                      }
                  })
                  break;
                  case 2:
                  item_el.each(function(){
                      var swatch_val = $(this).data('value');
                      var swatch_inventory_policy = $(this).data('inventory_policy');
                      var opt1_soldout = variants.find(function(variant){
                          if (opt_position == 1) {
                              return variant.option2 == selected_swatch_opt1 && variant.option1 == selected_swatch_opt2 && variant.option3 == swatch_val && variant.available;
                          } else {
                              if (opt_position == 2) {
                                return variant.option3 == selected_swatch_opt1 && variant.option1 == selected_swatch_opt2 && variant.option2 == swatch_val && variant.available;
                              } else {
                                return variant.option1 == selected_swatch_opt1 && variant.option2 == selected_swatch_opt2 && variant.option3 == swatch_val && variant.available;
                              }
                              
                          }
                          
                      });
                      var option_unavailable = variants.find(function(variant){
                          if (opt_position == 1) {
                              return variant.option2 == selected_swatch_opt1 && variant.option1 == selected_swatch_opt2 && variant.option3 == swatch_val;
                          } else {
                              if (opt_position == 2) {
                                return variant.option3 == selected_swatch_opt1 && variant.option1 == selected_swatch_opt2 && variant.option2 == swatch_val;
                              } else {
                                return variant.option1 == selected_swatch_opt1 && variant.option2 == selected_swatch_opt2 && variant.option3 == swatch_val;
                              }
                              
                          }
                      });
                      if(opt1_soldout == undefined){
                          if (option_unavailable == undefined) {
                              $(this).addClass('unavailable');
                              $(this).removeClass('soldout');
                              $(this).removeClass('available');
                              $(this).find(':radio').prop('checked',false);
                              $(this).attr('data-toggle', 'modal');
                              $(this).attr('data-target', '#Form_newletter');
                          } else {
                              $(this).addClass('soldout');
                              $(this).removeClass('unavailable');
                              $(this).removeClass('available');
                              $(this).find(':radio').prop('disabled',false);
                              $(this).attr('data-toggle', 'modal');
                              $(this).attr('data-target', '#Form_newletter');
                          }
                      } else {
                          $(this).removeClass('soldout');
                          $(this).removeClass('unavailable');
                          $(this).addClass('available');
                          $(this).find(':radio').prop('disabled',false);
                          $(this).removeAttr('data-toggle', 'modal');
                          $(this).removeAttr('data-target', '#Form_newletter');
                      }
                  })
                  break;
              }
            });
              if (item_swatch.find('.swatch-element.soldout').find('input:checked').length) {
                  item_swatch.find('[data-btn-addtocart]').attr('disabled', true);
              } else {
                  item_swatch.find('[data-btn-addtocart]').removeAttr('disabled');
              }
              item_swatch.find('.selector-wrapper:not(.opt-color)').each(function(){
                  if ($(this).find('.swatch-element').find('input:checked').length < 1) {
                      if ($(this).find('.swatch-element.available').length) {
                          $(this).find('.swatch-element.available').eq('0').find('label').trigger('click');
                      } else {
                          $(this).find('.swatch-element.soldout').eq('0').find('label').trigger('click');
                      }
                  }
              });
          }
          else {
            var product_info = product_item.data('json-product');
            var variants = product_info.variants;
            var options = product_item.find('.item-product__popup--variant [data-option]');
            var selected_swatch_opt1 = item_swatch.find('.item-product__popup--variant [data-option="option1"]').val();
            var selected_swatch_opt2 = item_swatch.find('.item-product__popup--variant [data-option="option2"]').val();
            var selected_swatch_opt3 = item_swatch.find('.item-product__popup--variant [data-option="option3"]').val();

            options.each(function(){
                var option_index = $(this).data('option-index');
                var swatch_el = $(this).find('option');
                switch (option_index) {
                  case 0:
                  swatch_el.each(function(){
                    var swatch_val = $(this).val();
                    var opt1_soldout = variants.find(function(variant){
                      return variant.option1 == swatch_val && variant.available;
                    })
                    if(opt1_soldout == undefined){
                      var option_unavailable = variants.find(function(variant){
                        return variant.option1 == swatch_val;
                      });
                      if (option_unavailable == undefined) {
                        $(this).addClass('unavailable');
                        $(this).removeClass('soldOut');
                        $(this).attr('disabled','disabled');
                      } else {
                        $(this).addClass('soldOut');
                        $(this).removeClass('unavailable');
                        $(this).removeAttr('disabled','disabled');
                      }
                    }
                    else {
                      $(this).removeAttr('disabled','disabled');
                      $(this).removeClass('soldOut');
                      $(this).removeClass('unavailable');
                    }
                  });
                  break;

                  case 1:
                  swatch_el.each(function(){
                    var swatch_val = $(this).val();
                    var opt1_soldout = variants.find(function(variant){
                      return variant.option1 == selected_swatch_opt1 && variant.option2 == swatch_val && variant.available;
                    });
                    if(opt1_soldout == undefined){
                      var option_unavailable = variants.find(function(variant){
                        return variant.option1 == selected_swatch_opt1 && variant.option2 == swatch_val;
                      });
                      if (option_unavailable == undefined) {
                        $(this).addClass('unavailable');
                        $(this).removeClass('soldOut');
                        $(this).attr('disabled','disabled');
                      } else {
                        $(this).addClass('soldOut');
                        $(this).removeClass('unavailable');
                        $(this).removeAttr('disabled','disabled');
                      }
                    } else {
                        $(this).removeAttr('disabled','disabled');
                        $(this).removeClass('soldOut');
                        $(this).removeClass('unavailable');
                    }
                  });
                  break;

                  case 2:
                  swatch_el.each(function(){
                    var swatch_val = $(this).val();
                    var opt1_soldout = variants.find(function(variant){
                      return variant.option1 == selected_swatch_opt1 && variant.option2 == selected_swatch_opt2 && variant.option3 == swatch_val && variant.available;
                    });
                    if(opt1_soldout == undefined){
                      var option_unavailable = variants.find(function(variant){
                        return variant.option1 == selected_swatch_opt1 && variant.option2 == selected_swatch_opt2 && variant.option3 == swatch_val;
                      });
                      if (option_unavailable == undefined) {
                        $(this).addClass('unavailable');
                        $(this).removeClass('soldOut');
                        $(this).attr('disabled','disabled');
                      } else {
                        $(this).addClass('soldOut');
                        $(this).removeClass('unavailable');
                        $(this).removeAttr('disabled','disabled');
                      }
                    } else {
                      $(this).removeAttr('disabled','disabled');
                      $(this).removeClass('soldOut');
                      $(this).removeClass('unavailable');
                    }
                  });
                  break;
                }
            });
            if (item_swatch.find('.item-product__popup--variant .single-option-selector').find('option.soldOut:selected').length) {
              item_swatch.find('[data-btn-addtocart]').addClass('disabled').attr('disabled', true);
            } else {
              item_swatch.find('[data-btn-addtocart]').removeClass('disabled').removeAttr('disabled');
            }
          }
        },
        initNovWishListsPage: function() {
            if (typeof(Storage) !== 'undefined') {               
                if (wishListsArr.length <= 0) {
                   return;
                }

                wishListsArr.forEach(function(item) {
                   nuranium.createNovWishListTplItem(item);           
                });
            } else {
                alert('Storage no support!');
            }
        },
        
        initNovWishListIcons: function() {
            if (!wishListsArr.length) {
                return;
            }

            for (var i = 0; i < wishListsArr.length; i++) {
                var icon = $('[data-product-handle="'+ wishListsArr[i] +'"]');
                icon.addClass('whislist-added');
                icon.find('.wishlist-text').text(theme.strings.remove_wishlist);
            };

            if (typeof(Storage) !== 'undefined') {
                if (wishListsArr.length <= 0) {
                    return;
                }

                setTimeout(function() {
                    wishListsArr.forEach(function(item) {
                        nuranium.setNovAddedForWishlistIcon(item);     
                    });
                }, 1000);
            } else {
                alert('Storage no support!');
            }
        },
        
        setNovAddedForWishlistIcon: function(ProductHandle) {
            var wishlistElm = $('[data-product-handle="'+ ProductHandle +'"]');
            var textadd = theme.strings.addto_wishlist;
            var textremove = theme.strings.remove_wishlist;
            idxArr = wishListsArr.indexOf(ProductHandle);
            $('.WishlistCount').text(wishListsArr.length);
            if (idxArr >= 0) {
                wishlistElm.addClass('whislist-added');
                wishlistElm.find('.wishlist-text').text(textremove);
                wishlistElm.attr('title',textremove);
            }
            else {
                wishlistElm.removeClass('whislist-added');
                wishlistElm.find('.wishlist-text').text(textadd);
                wishlistElm.attr('title',textadd);
            };
        },
          
        doAddOrRemoveWishlist: function() {   
            var iconWishLists = '.item-product [data-icon-wishlist]';
            var textadd = theme.strings.addto_wishlist;
            var textremove = theme.strings.remove_wishlist;
        
            $(document).off('click.addOrRemoveWishlist', iconWishLists).on('click.addOrRemoveWishlist', iconWishLists, function(e) {
                e.preventDefault();
                var self = $(this),
                    productId = self.data('id'),
                    ProductHandle = self.data('product-handle'),
                    idxArr = wishListsArr.indexOf(ProductHandle);

                if (!self.hasClass('whislist-added')) {
                    self.addClass('whislist-added');
                    self.find('.wishlist-text').text(textremove);
                    self.attr({'title':textremove, 'data-original-title':textremove});
                    $('.tooltip-inner').text(textremove);

                    var title = self.parents('.item-product').find('.product__title').html();
                    var image = self.parents('.item-product').find('.product__thumbnail').attr('srcset') 
                    ? self.parents('.item-product').find('.product__thumbnail').attr('srcset') 
                    : self.parents('.item-product').find('.product__thumbnail').attr('src');

                    $('.loading-modal').find('.product-title').html(title);
                    $('.loading-modal').find('.product-image').attr('srcset', image);
                    $('.loading-modal').find('.btn-wishlist').show();
                    $('.loading-modal').css({"opacity": "1", "visibility": "initial", "transform": "translateX(0)", "transition": "all 0.3s"});
                    $('.loading-modal').addClass('novload');
                    setTimeout(function() {
                        $('.loading-modal').css({"opacity": "0", "visibility": "hidden", "transform": "translateX(410px)", "transition": "all 0.3s"});
                        $('.loading-modal').removeClass('novload');
                    }, 5000);

                    if ($('[data-wishlist-container]').length) {
                        nuranium.createNovWishListTplItem(ProductHandle);
                    };

                    wishListsArr.push(ProductHandle);
                    localStorage.setItem('wishListsArr', JSON.stringify(wishListsArr));

                } else {
                    self.removeClass('whislist-added');
                    self.find('.wishlist-text').text(textadd);
                    self.attr({'title':textadd, 'data-original-title':textadd});
                    $('.tooltip-inner').text(textadd);
                    if ($('[data-wishlist-added="wishlist-'+productId+'"]').length) {
                        $('[data-wishlist-added="wishlist-'+productId+'"]').remove();
                    }

                    wishListsArr.splice(idxArr, 1);
                    localStorage.setItem('wishListsArr', JSON.stringify(wishListsArr));
                };

                nuranium.setNovAddedForWishlistIcon(ProductHandle);
            });
        },

        doAddOrRemoveWishlistProduct: function() {
            var iconWishLists = '.product-single a[data-icon-wishlist]';

            $(document).off('click.addOrRemoveWishlist', iconWishLists).on('click.addOrRemoveWishlist', iconWishLists, function(e) {
                e.preventDefault();

                var self = $(this),
                productId = self.data('id'),
                ProductHandle = self.data('product-handle'),
                idxArr = wishListsArr.indexOf(ProductHandle);

                if (!self.hasClass('whislist-added')) {
                    self.addClass('whislist-added');
                    self.find('.wishlist-text').text(theme.strings.remove_wishlist);

                    var title = self.parents('.product-single').find('.product-single__title').html();
                    var image = self.parents('.product-single').find('.product-single__photos .thumblist .thumbItem img').attr('src');
                    $('.loading-modal').find('.product-title').html(title);
                    $('.loading-modal').find('.product-image').attr('src', image);
                    $('.loading-modal').find('.btn-wishlist').show();
                    $('.loading-modal').css({"opacity": "1", "visibility": "initial", "transform": "translateX(0)", "transition": "all 0.3s"});
                    $('.loading-modal').addClass('novload');
                    setTimeout(function() {
                        $('.loading-modal').css({"opacity": "0", "visibility": "hidden", "transform": "translateX(410px)", "transition": "all 0.3s"});
                        $('.loading-modal').removeClass('novload');
                    }, 5000);

                    if ($('[data-wishlist-container]').length) {
                        nuranium.createNovWishListTplItem(ProductHandle);
                    };

                    wishListsArr.push(ProductHandle);
                    localStorage.setItem('wishListsArr', JSON.stringify(wishListsArr));

                } else {
                    self.removeClass('whislist-added');
                    self.find('.wishlist-text').text(theme.strings.addto_wishlist);
                    if ($('[data-wishlist-added="wishlist-'+productId+'"]').length) {
                        $('[data-wishlist-added="wishlist-'+productId+'"]').remove();
                    }

                    wishListsArr.splice(idxArr, 1);
                    localStorage.setItem('wishListsArr', JSON.stringify(wishListsArr));
                };

                nuranium.setNovAddedForWishlistIcon(ProductHandle);
            });
        },
        
        createNovWishListTplItem: function(ProductHandle) {
            var wishListCotainer = $('[data-wishlist-container]');

            jQuery.getJSON(window.router + '/products/'+ProductHandle+'.js', function(product) {
                var productHTML = '',
                    price_min = Shopify.formatMoney(product.price_min, theme.moneyFormat),
                    compare_at_price_min = Shopify.formatMoney(product.compare_at_price_min, theme.moneyFormat),
                    variants = JSON.stringify(product.variants),
                    media = JSON.stringify(product.media);

                productHTML += '<div class="item col-lg-3 col-md-4 col-6" data-wishlist-added="wishlist-'+product.id+'">';
                productHTML += '<div class="item-product" data-product-id="product-'+product.handle+'">';
                productHTML += '<div class="inner-top">';
                if (typeof(product.images[1]) !== 'undefined') {
                    productHTML += '<div class="product-top thumbnail-container has-multiimage">';
                } else {
                    productHTML += '<div class="product-top thumbnail-container">';
                }
                productHTML += '<a href="'+product.url+'">';
                productHTML += '<img class="product__thumbnail" src="'+product.featured_image+'" alt="'+product.featured_image.alt+'">'
                if (typeof(product.images[1]) !== 'undefined') {
                productHTML += '<img class="product__thumbnail-second" src="'+product.images[1]+'" alt="'+product.images[1].alt+'">'   
                }
                productHTML += '</a>'
                productHTML += '<div class="button--top">'
                productHTML += '<div class="productWishList">';
                productHTML += '<a class="btnProductWishlist item-product__wishlist whislist-added" data-icon-wishlist href="#" data-product-handle="'+product.handle+'" data-id="'+product.id+'">';
                productHTML += '<i class="zmdi zmdi-favorite"></i>';
                productHTML += '</a>';
                productHTML += '</div>';
                productHTML += '<div class="productQuickView d-none d-md-block">'
                productHTML += '<a class="btnProductQuickview" href="#" data-url="/products/'+product.handle+'?view=quick_view" data-product-url="/products/'+product.handle+'"  data-handle="'+product.handle+'" data-pid="'+product.id+'">';
                productHTML += '<i class="zmdi zmdi-collection-image-o"></i>';
                productHTML += '</a>';
                productHTML += '</div>';

                productHTML += '</div>';
                productHTML += '</div>';
                productHTML += '<div class="product__info">';
                productHTML += '<div class="product__title"><a href="'+product.url+'" title="'+product.title+'">'+product.title+'</a></div>';
                if (compare_at_price_min > price_min) {
                    productHTML += '<div class="price-sale">';
                    productHTML += '<span class="special-price" data-price-grid>'+ price_min +'</span>';
                    productHTML += '<span class="old-price" data-compare-price-grid>'+ compare_at_price_min +'</span>';
                    productHTML += '</div>';
                } else {
                    productHTML += '<div class="price-regular">';
                    productHTML += '<span data-price-grid>'+ price_min +'</span>';
                    productHTML += '</div>';
                }
                productHTML += '</div></div></div>';

                wishListCotainer.append(productHTML);
            });
        },
          
        ajaxAddToCart: function() {
          $( document ).on('click', 'button.btnAddToCart', function(e) {
            var $this = $(this);
            e.preventDefault();
            $this.css('pointer-events', 'none').addClass('loading');
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: $this.parents('form').serialize(),
              dataType: 'json',
              success:function( cart ) {
                $.get('/cart?view=json', function(data) {
                  $('#cart-info').html(data);
                }).always(function() {
                  
                  if (theme.cart_status == 'show_popup') {
                  	nuranium.initAddToCart(cart.image, cart.title);
                  }
                  if(!$('.form-cart__extent').length) {
                    nuranium.initCartExtend();
                  }
                  
                  nuranium.updateMiniCart();
                  
                  nuranium.PopupAddToCart();
                  $this.parents('form').find('.product-form__item-error').addClass('hidden');
                  $this.css('pointer-events', 'auto').removeClass("loading");
                  $(document).find('.quickviewClose').trigger('click');
                  if (theme.cart_status == 'show_minicart') {
                    setTimeout(function() {
                        $("#desktop_cart").addClass('active');
                        $(".sidebar-overlay").addClass('act');
                    }, 300);
                  }
                });
              },
              error: function(XMLHttpRequest, textStatus) {
                $this.removeClass("loading").css('pointer-events', 'auto');
                $this.parents('form').find('.product-form__item-error').removeClass('hidden');
              }
            })
          })
        },
        
        initAddToCart : function(image, title) {
          $.ajax({
            url: '/cart/?view=upsell',
            dataType: 'html',
            type: 'GET',
            beforeSend : function (){
              $( 'body' ).addClass('cart_popup_opened');
            },
            success: function(data) {
              $.magnificPopup.open({
                items: {
                  src: '<div class="nov-with-anim product-quickview popup-quick-view cart__popup cart__popup_upsell"><div id="content_cart__popup_nt">' + data + '</div></div>',
                  type: 'inline'
                },
                removalDelay: 500,
                closeMarkup: '<i class="zmdi zmdi-hc-fw zmdi-close"></i>',
                callbacks: {
                  beforeOpen: function() {
                    this.st.mainClass = 'nov-move-horizontal';
                  },
                  open: function() {
                    nuranium.PopupAddToCart();
                  },
                  change: function() { },
                  close: function() {
                    if($('body').hasClass('template-cart')) {
                      window.location.reload();
                    }
                    else {
                      $('body').removeClass('cart_popup_opened');
                      $('body').removeClass('open_quick_variants');
                      $('body').removeClass('loading');
                      $('#content_cart__popup_nt').empty();
                    }
                  }
                },
              });
            },
            complete: function() {
              nuranium.PopupAddToCart();
              $('.loader').remove();
              if (title) {
                var cartMessage = '<div class="cart-message d-flex align-items-center mb-20">' +
                  '<i class="zmdi zmdi-notifications-active"></i><strong>' +
                  title  +'</strong> - '+ theme.strings.cart_message_html +
                  '</div>';
                $('.cart-popup__content').prepend(cartMessage);
              }
            },
            error: function() {
              $('.loader').remove();
            }
          });
        },
        
        updateMiniCart: function() {
          Shopify.getCart(function(cart) {
            nuranium.doUpdateMiniCart(cart);
          });
        },

        doUpdateMiniCart: function(cart) {
            $('#CartCount, #CartCountCavas').text(cart.item_count);
            $('#cart_total').html(Shopify.formatMoney(cart.total_price, theme.moneyFormat));
            $('.cart-popup-heading span').html('There are ' + cart.item_count + ' item(s) in your cart');
        },

        ajaxChangeFromCart: function() {
          $( document ).on( 'change','.cart__popup-qty--input, .cart__mini-qty--input', function( e ) {
            e.preventDefault();
          })
        },
              
        PopupAddToCart: function() {
          function PopupUpdateCart(_id, new_qty) {
            $('.cart__popup').addClass('loading');
            $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: 'quantity=' + new_qty + '&id=' + _id,
                dataType: 'json',
                success: function (cart) {
                jQuery.get('/cart?view=up_ajax', function (data) {
                    data = jQuery(data);
                    var sdata = jQuery(data);
                    var t_html = jQuery(sdata.get(0)).html(),
                        t_threshold = jQuery(sdata.get(2)).html(),
                        t_total = $('.cart__popup #' + _id).find('.cart__popup-total .amount');

                    $('.cart__popup #' + _id).find('.cart__popup-qty--input').val(new_qty);

                    var price = parseFloat(t_total.data('price')) * new_qty;
                    t_total.html(Shopify.formatMoney(price, theme.moneyFormat));
                    $('#cart__popup_total').html(t_html);
                    $('#threshold_bar_popup').html(t_threshold);
                }).always(function () {
                    $('.cart__popup').removeClass('loading');
                });

                $.get('/cart?view=json', function (data) {
                    $('#cart-info').html(data);
                    }).always(function () {
                        nuranium.updateMiniCart();
                    });
                },
                error: function (XMLHttpRequest, textStatus) {
                    $('.cart__popup').removeClass('loading');
                }
            });
          }
          
          $(document).on('click', '.cart__popup-qty', function (e) {
            e.preventDefault();
            var $this = $(this),
                $qty = $this.siblings('.cart__popup-qty--input'),
                $id = $qty.attr('data-id'),
                $qtyinput = parseFloat($qty.val()),
                $step = parseFloat($qty.attr('step')),
                $min = parseFloat($qty.attr('min')),
                $max = parseFloat($qty.attr('max'));
            
            if ($this.hasClass('cart__popup-qty--plus')) {
              var $newqty = $qtyinput + $step;
              if ($newqty > $max && $max > 0) {
                $qty.val($max);
                return;
              }
            }
            else if ($this.hasClass('cart__popup-qty--minus')) {
              var $newqty = $qtyinput - $step;
              if ($newqty === 0) {
                var last_qty = parseInt($qty.attr('value'));
                $qty.val(last_qty);
                $this.parents('.cart__popup-item').find('.cart__popup-remove').trigger('click');
                return;
              } else if ($newqty < $min) {
                return;
              } else if ($qtyinput < 0) {
                alert('Invalid');
                return;
              }
            }
            
            PopupUpdateCart($id, $newqty);
          });
          
          $(document).on('click', '.cart__popup-remove', function (e) {
            e.preventDefault();
            
            $('.cart__popup').addClass('loading');
            
            var $this = $(this),
                $qty = $this.siblings('.cart__popup-quantity').find('.cart__popup-qty--input'),
                $id = $this.find('a').attr('data-product-id'),
                $qtyinput = parseInt($qty.val());
                $ptitle = $this.parent('.cart__popup-item').find('.cart__popup-title a').text();
            
            $('.cart__popup').addClass('loading');
            
            $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              data: 'quantity=0&id=' + $id,
              dataType: 'json',
              success: function (cart) {
                jQuery.get('/cart?view=up_ajax', function (data) {}).always(function (data) {
                  data = jQuery(data);
                  var sdata = jQuery(data);
                  var t_html = jQuery(sdata.get(0)).html(),
                      t_threshold = jQuery(sdata.get(2)).html();;
                  $('#cart__popup_total').html(t_html);
                  $('#threshold_bar_popup').html(t_threshold);
                  $('.cart__popup #' + $id).addClass('hide');
                  if ($qtyinput > 0) {
                    $('#' + $id + ' input').val($qtyinput)
                  } else {
                    $('.cart__popup #' + $id + ' input').val(1)
                  }
                  
                  
                  $('.cart__popup .cart-message').html('<i class="rbb-icon-delete-outline-2"></i> <strong>'+ $ptitle +'</strong> - has been removed into your shopping cart.');
                  
                  $('.cart__popup .cart-message').removeClass('removed').addClass('removed');
                  
                  $('.cart__popup').removeClass('loading');
                  
                  $this.parents('.cart__popup-item').remove();
                });
                
                $.get('/cart?view=json', function (data) {
                  $('#cart-info').html(data);
                }).always(function () {
                  
                  nuranium.updateMiniCart();
                });
              }
            })
          });
        },

       initMiniCart: function() {
            var CART_VIEW = '/cart?view=json';   // enhanced Liquid markup (cart-ajax.liquid)
 
            jQuery.getJSON('/cart.js', function (cart) {
                $('#CartCount, #CartCountCavas').text(cart.item_count);
                $('#cart_total').html(Shopify.formatMoney(cart.total_price, theme.moneyFormat));
 
                if (cart.item_count > 0) {
                    $('#desktop_cart').addClass('item_count');
 
                    // Load the same server-rendered cart everything else uses,
                    // so the Cart Pro modules render with correct settings/prices.
                    $.get(CART_VIEW, function (data) {
                        $('#cart-info').html(data);
                    }).always(function () {
                        // Re-run the original footer scroll-height check.
                        var i = $('.ajaxcart__inner').outerHeight();
                        var f = $('.ajaxcart__footer').outerHeight();
                        var c = $('.ajaxcart').height() - 30;
                        if (i + f >= c) {
                            $('.ajaxcart__footer').addClass('h_scroll');
                        }
                        // Re-attach the slide-out note / shipping / discount panels.
                        if (!$('.form-cart__extent').length) {
                            nuranium.initCartExtend();
                        }
                    });
                } else {
                    // Empty-cart state (unchanged from the original).
                    var link_collection = $('.link_to_collection_cart_empty').html();
                    var html = '';
                    html += '<div class="cart cart_empty">';
                    html += '<div class="empty_title text-center">' + theme.strings.cart_empty + '</div>';
                    html += '<div class="text-center mt-40 block_link_cart">';
                    html += '' + (link_collection || '') + '';
                    html += '</div>';
                    html += '</div>';
                    $('#cart-info').html(html);
                    $('#cart_total').html(Shopify.formatMoney(0, theme.moneyFormat));
                    $('#desktop_cart').removeClass('item_count');
                    $('.form-cart__extent').remove();
                }
            });
        },
 
        
        ajaxProductAddToCart: function() {
          $(document).on('click', '.product-form__cart-submit', function(e) {
            e.preventDefault();
            var $this = $(this);
            $this.css('pointer-events', 'none').addClass('loading');
            $('.lookbook-modal').modal('hide');
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: $this.parents('form').serialize(),
              dataType: 'json',
              success:function( cart ) {
                $.get('/cart?view=json', function(data) {
                  $('#cart-info').html(data);
                }).always(function() {
                  if (theme.cart_status == 'show_popup') {
                  	nuranium.initAddToCart(cart.image, cart.title);
                  }
                  if(!$('.form-cart__extent').length) {
                    nuranium.initCartExtend();
                  }
                  nuranium.updateMiniCart();
                  
                  nuranium.PopupAddToCart();
                  
                  $this.css('pointer-events', 'auto').removeClass("loading");
                  $('.cart_extend').removeClass('act');
                  $('.cart_extend--label').removeClass('act');
                });
              },
              complete: function() {
                $('body').removeClass('cart_popup_opened');
                $('body').removeClass('loading');
                $('.nov-close, .cart_popup_opened .nov-ready').on('click', function() {
                  if($('body').hasClass('template-cart')) {
                    window.location.reload();
                  }
                })
                if (theme.cart_status == 'show_minicart') {
                    setTimeout(function() {
                        $("#desktop_cart").addClass('active');
                        $(".sidebar-overlay").addClass('act');
                    }, 1000);
                }
                $(document).find('.zmdi-close').trigger('click');
              },
              error: function(XMLHttpRequest, textStatus) {
                $this.removeClass("loading").css('pointer-events', 'auto').find('.add-to-cart-text').text(window.inventory_text.sold_out);
              }
            }).done(function() {
                $('body').removeClass('loading');
            })
          })
        },
        initQuickView: function() {
          $(document).on('click', '.btnProductQuickview', function(e) {
            e.preventDefault();
            $('.lookbook-modal').modal('hide');
            var $this = $(this);
            $.ajax({
              beforeSend : function (){
                $('body').addClass('open_gl_quick_view');
              },
              url: $this.attr('data-url'),
              success: function(data) {
                   $.magnificPopup.open({
                     items: {
                       src: '<div class="nov-with-anim popup-quick-view" id="content_quickview">' + data + '</div>', // can be a HTML string, jQuery object, or CSS selector
                       type: 'inline'
                     },
                     removalDelay: 500,
                     closeMarkup: '<i class="zmdi zmdi-hc-fw zmdi-close"></i>',
                     callbacks: {
                       beforeOpen: function() {
                         this.st.mainClass = 'nov-move-horizontal';
                       },
                       open: function() {
                         if ($('html').hasClass('lang-rtl'))
                              rtl = true;
                          else
                              rtl = false;
                          $('.quickview_slick').slick({
                             nextArrow: '<div class="arrow-next"><i class="zmdi zmdi-chevron-right"></i></div>',
                             prevArrow: '<div class="arrow-prev"><i class="zmdi zmdi-chevron-left"></i></div>',
                             rtl: rtl,
                             slidesToShow: 1,
                             slidesToScroll: 1,
                             arrows: true,
                             dots: false,
                             infinite: true,
                             adaptiveHeight: !0
                         });
                         $('variant-radios label').click(function () {
                              setTimeout(function() {
                                  var dindex = $('.quickview_slick').find('.item.act').attr('data-slick-index');
                                  $('.quickview_slick').slick('slickGoTo', dindex);
                              }, 300);
                          })
                         Shopify.PaymentButton.init();
                         
                         
                         setTimeout(function () {
                            if ($('.shopify-product-reviews-badge').length && $('.spr-badge').length) {
                                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                            };
                         }, 1000);
                         nuranium.initNovWishListIcons();
                         if ($('.jdgm-widget').length) {
                            jdgm.customizeBadges()
                         }
                         jQuery('variant-radios :radio').change(function() {
                           var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
                           var optionValue = jQuery(this).val();
                           jQuery(this).parents('fieldset').find('.variant_current').text(optionValue);
                         });
                         $(document).on('click', '#content_quickview .soldout', function(){
                            $('#content_quickview .zmdi-close').trigger('click');
                         });
                       },
                       close: function() {
                         $( '#content_quickview' ).empty();
                         $('body').removeClass('open_gl_quick_view');
                         $('body').removeClass('cart_popup_opened');
                         $('body').removeClass('open_quick_variants');
                         $('body').find('.tooltip').remove();
                       }
                     },
                  });
              },
              complete: function() {
                Shopify.PaymentButton.init();
              }
            }).done(function() {
                $this.removeClass('btn-loading');
                $('body').removeClass('loading');
                $('body').find('.tooltip').remove();
            })
            const product_url = this.getAttribute('data-product-url');
            fetch(product_url)
              .then((response) => response.text())
              .then((responseText) => {
                const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
                const sectionId = responseHTML.querySelector('.product-template__container').getAttribute('data-section-id');
                const content_quickview = document.getElementById("content_quickview");
                
                content_quickview.querySelector('variant-radios').setAttribute('data-section', sectionId);
                content_quickview.querySelector('.product-template__container').setAttribute('data-section-id', sectionId);
                content_quickview.querySelector('.product-template__container').id = 'ProductSection-' + sectionId;
                content_quickview.querySelector('#ProductPrice-templateQV').id = 'ProductPrice-' + sectionId;
                if (content_quickview.querySelector('#ComparePrice-templateQV')) {
                  content_quickview.querySelector('#ComparePrice-templateQV').id = 'ComparePrice-' + sectionId;
                }
                content_quickview.querySelector('form').id = 'product-form-' + sectionId;
                content_quickview.querySelector('form').setAttribute('data-section', sectionId);
                item = content_quickview.querySelectorAll('.item_img');
                for (var i = 0; i < item.length; i++) {
                  mediaId = item[i].getAttribute('data-media-id');
                  item[i].setAttribute('data-media-id', sectionId + mediaId);
                }
                input = content_quickview.querySelectorAll('input[type=radio]');
                for (var i = 0; i < input.length; i++) {
                  input[i].setAttribute('form', sectionId);
                }
              })
            })
        },
        ajaxRemoveFromCart: function() {
          $('#cart-info').on('click', '.remove-from-cart', function(e){
            e.preventDefault();
            
            var $this = $(this),
                $id = $this.attr('data-product-id');

            $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              data: 'quantity=0&id=' + $id,
              dataType: 'json',
              success: function (cart) {
                if ($('body').hasClass('template-cart')) {
                  window.location.reload();
                }
                else {
                  nuranium.initMiniCart();
                }
              }
            })
          });
        },
        changeQuantityMiniCart: function() {
            function MiniCartUpdate(_id, new_qty) {
                $.ajax({
                    type: 'POST',
                    url: '/cart/change.js',
                    data: 'quantity=' + new_qty + '&id=' + _id,
                    dataType: 'json',
                    success: function (cart) {
                    jQuery.get('/cart?view=up_ajax', function (data) {
                        data = jQuery(data);
                        var sdata = jQuery(data);
                        var t_html = jQuery(sdata.get(0)).html(),
                            t_threshold = jQuery(sdata.get(2)).html();
                            t_total = $('#cart-info').find('.subtotal');
                        $('#cart-info').find('.subtotal span').html(t_html);
                        $('#threshold_bar_popup_minicart .cart_threshold').html(t_threshold);
                    }).always(function () {
                    });

                    $.get('/cart?view=json', function (data) {
                        $('#cart-info').html(data);
                        }).always(function () {
                            nuranium.updateMiniCart();
                        });
                    },
                });
            }
            $(document).on('click', '.cart__mini-qty', function (e) {
                e.preventDefault();
                var $this = $(this),
                    $qty = $this.siblings('.cart__mini-qty--input'),
                    $id = $qty.attr('data-id'),
                    $qtyinput = parseFloat($qty.val()),
                    $step = parseFloat($qty.attr('step')),
                    $min = parseFloat($qty.attr('min')),
                    $max = parseFloat($qty.attr('max'));
                if ($this.hasClass('cart__mini-qty--plus')) {
                    var $newqty = $qtyinput + $step;
                    if ($newqty > $max && $max > 0) {
                        $qty.val($max);
                        return;
                    } else {
                         $qty.val($newqty);
                    }
                } else if ($this.hasClass('cart__mini-qty--minus')) {
                    var $newqty = $qtyinput - $step;
                    if ($newqty === 0) {
                        var last_qty = parseInt($qty.attr('value'));
                        $qty.val(last_qty);
                        $this.parents('.ajaxcart__product').find('.remove-from-cart').trigger('click');
                        return;
                    } else if ($newqty < $min) {
                        return;
                    } else if ($qtyinput < 0) {
                        alert('Invalid');
                        return;
                    }
                    else {
                        $qty.val($newqty);
                    }
                }

                MiniCartUpdate($id, $newqty);
            });
            $(document).on('change', '.cart__mini-qty--input', function (e) {
                var $this = $(this),
                $newqty = parseFloat($this.val()),
                $id = $this.attr('data-id'),
                $min = parseFloat($this.attr('min')),
                $max = parseFloat($this.attr('max'));
                if ($newqty > $max && $max > 0) {
                    $newqty.val($max);
                    return;
                }
                if ($newqty === 0) {
                    $this.parents('.ajaxcart__product').find('.remove-from-cart').trigger('click');
                    return;
                }
                MiniCartUpdate($id, $newqty);
            });
        },
        changeQuantityPageCart: function() {
            function ShopifyCartChange(variant_id, quantity, callback) {
                var params = {
                    type: 'POST',
                    url: '/cart/change.js',
                    data:  'quantity='+quantity+'&line='+variant_id,
                    dataType: 'json',
                    success: function(cart) { 
                        if ((typeof callback) === 'function') {
                            callback(cart);
                        }
                    },
                    error: function(XMLHttpRequest, textStatus) {
                    }
                };
                jQuery.ajax(params);
            }

            $( document ).on( 'change keyup', '.cart__qty-input, .cart__popup-qty--input', function() {
                var $this = $(this);
                var line = $this.data('line'),
                val = parseInt($this.val()),
                price = $this.data('price'),
                max = $this.attr('max');
                if(isNaN(val)) return 0;

                max = isNaN(parseInt(max)) ? 9999: parseInt(max);
                if(val > max ){
                    $this.attr('value', max).val(max);
                }
                val = (val > max) ? max : val;
                if(val <= 0 ){
                    $this.closest('tr').remove();
                }

                ShopifyCartChange(line, val, function(res){
                    $('.cart__subtotal').html(Shopify.formatMoney(res.total_price, theme.moneyFormat));

                    $this.parents('.cart_item').find('.product-subtotal').html(Shopify.formatMoney(price * val, theme.moneyFormat));

                    $('#CartCount, #CartCountCavas').html(res.item_count);

                    $('.cart__heading span').html('There are '+res.item_count+' items in your cart');


                    jQuery.get('/cart?view=ship', function(data) {
                        $('#threshold_bar_popup').html(data);
                        setTimeout(function() {
                        }, 200);   
                    });
                    $.get('/cart?view=json', function (data) {
                        $('#cart-info').html(data);
                    }).always(function () {
                        nuranium.updateMiniCart();
                    });
                });
            });

            $( document ).on( 'click', '.plus, .minus', function() {
                var $qty = $( this ).closest( '.cart__qty' ).find( '.cart__qty-input'),
                currentVal = parseFloat( $qty.val() ),
                max = parseFloat( $qty.attr( 'max' ) ),
                min = parseFloat( $qty.attr( 'min' ) ),
                step = $qty.attr( 'step' );

                if (! currentVal || currentVal === '' || currentVal === 'NaN') currentVal = 0;
                if (max === '' || max === 'NaN') max = '';
                if (min === '' || min === 'NaN') min = 0;
                if (step === 'any' || step === '' || step === undefined || parseFloat(step) === 'NaN') step = 1;

                if ($(this).is( '.plus')) {
                    if ( max && (currentVal >= max)) {
                        $qty.val( max );
                    } else {
                        $qty.val((currentVal + parseFloat(step)));
                    }
                } else {
                    if ( min && ( currentVal <= min ) ) {
                        $qty.val( min );
                    } else if (currentVal > 0) {
                        $qty.val((currentVal - parseFloat( step )));
                    }
                }
                $qty.trigger( 'change' );
            });

            $( document ).on( 'click', '.quick_view-qty-plus, .quick_view-qty-minus', function() {
                var $qty = $(this).closest( '.quick_view_qty' ).find( 'input[name="quantity"]'),
                currentVal = parseFloat($qty.val()),
                max = parseFloat($qty.attr('max')),
                min = parseFloat($qty.attr('min')),
                step = $qty.attr('step');

                if (!currentVal || currentVal === '' || currentVal === 'NaN') currentVal = 0;
                if (max === '' || max === 'NaN') max = '';
                if (min === '' || min === 'NaN') min = 0;
                if (step === 'any' || step === '' || step === undefined || parseFloat(step) === 'NaN') step = 1;

                if ($(this).is( '.quick_view-qty-plus')) {
                    if ( max && (currentVal >= max)) {
                        $qty.val( max );
                    } else {
                        $qty.val((currentVal + parseFloat(step)));
                    }
                } else {
                    if ( min && ( currentVal <= min ) ) {
                        $qty.val( min );
                    } else if (currentVal > 0) {
                        $qty.val((currentVal - parseFloat( step )));
                    }
                }
            });
        },
        initCartExtend: function() {
            jQuery.get('/cart?view=extend', function(data) {
                $('.block_cart_top').before(data);
                if ($('html').hasClass('lang-rtl')) {
                    $('.extend--label__item').attr('data-placement','right');
                } else {
                    $('.extend--label__item').attr('data-placement','left');
                }
            });
            setTimeout(function () {
                if ($('#shipping-calculator').length > 0) {
                    "object"==typeof Countries&&(Countries.updateProvinceLabel=function(e,t){if("string"==typeof e&&Countries[e]&&Countries[e].provinces){if("object"!=typeof t&&(t=document.getElementById("address_province_label"),null===t))return;t.innerHTML=Countries[e].label;var r=jQuery(t).parent();r.find("select");r.find(".custom-style-select-box-inner").html(Countries[e].provinces[0])}}),"undefined"==typeof Shopify.Cart&&(Shopify.Cart={}),Shopify.Cart.ShippingCalculator=function(){var _config={submitButton:"Calculate shipping",submitButtonDisabled:"Calculating...",templateId:"shipping-calculator-response-template",wrapperId:"wrapper-response",customerIsLoggedIn:!1,moneyFormat:"${{amount}}"},_render=function(e){var t=jQuery("#"+_config.templateId),r=jQuery("#"+_config.wrapperId);if(t.length&&r.length){var templateSettings={evaluate:/<%([\s\S]+?)%>/g,interpolate:/<%=([\s\S]+?)%>/g,escape:/<%-([\s\S]+?)%>/g};var n=Handlebars.compile(jQuery.trim(t.text())),a=n(e);if(jQuery(a).appendTo(r),"undefined"!=typeof Currency&&"function"==typeof Currency.convertAll){var i="";jQuery("[name=currencies]").length>0?i=jQuery("[name=currencies]").val():jQuery("#currencies span.selected").length>0&&(i=jQuery("#currencies span.selected").attr("data-currency")),""!==i&&Currency.convertAll(shopCurrency,i,"#wrapper-response span.money, #estimated-shipping span.money")}}},_enableButtons=function(){jQuery(".get-rates").removeAttr("disabled").removeClass("disabled").val(_config.submitButton)},_disableButtons=function(){jQuery(".get-rates").val(_config.submitButtonDisabled).attr("disabled","disabled").addClass("disabled")},_getCartShippingRatesForDestination=function(e){var t={type:"POST",url:"/cart/prepare_shipping_rates",data:jQuery.param({shipping_address:e}),success:_pollForCartShippingRatesForDestination(e),error:_onError};jQuery.ajax(t)},_pollForCartShippingRatesForDestination=function(e){var t=function(){jQuery.ajax("/cart/async_shipping_rates",{dataType:"json",success:function(r,n,a){200===a.status?_onCartShippingRatesUpdate(r.shipping_rates,e):setTimeout(t,500)},error:_onError})};return t},_fullMessagesFromErrors=function(e){var t=[];return jQuery.each(e,function(e,r){jQuery.each(r,function(r,n){t.push(e+" "+n)})}),t},_onError=function(XMLHttpRequest,textStatus){jQuery("#estimated-shipping").hide(),jQuery("#estimated-shipping em").empty(),_enableButtons();var feedback="",data=eval("("+XMLHttpRequest.responseText+")");feedback=data.message?data.message+"("+data.status+"): "+data.description:"Error : "+_fullMessagesFromErrors(data).join("; ")+".","Error : country is not supported."===feedback&&(feedback="We do not ship to this destination."),_render({rates:[],errorFeedback:feedback,success:!1}),jQuery("#"+_config.wrapperId).show()},_onCartShippingRatesUpdate=function(e,t){_enableButtons();var r="";if(t.zip&&(r+=t.zip+", "),t.province&&(r+=t.province+", "),r+=t.country,e.length){"0.00"==e[0].price?jQuery("#estimated-shipping em").html("FREE"):jQuery("#estimated-shipping em").html(_formatRate(e[0].price));for(var n=0;n<e.length;n++)e[n].price=_formatRate(e[n].price)}_render({rates:e,address:r,success:!0}),jQuery("#"+_config.wrapperId+", #estimated-shipping").fadeIn()},_formatRate=function(e){function t(e,t){return"undefined"==typeof e?t:e}function r(e,r,n,a){if(r=t(r,2),n=t(n,","),a=t(a,"."),isNaN(e)||null==e)return 0;e=(e/100).toFixed(r);var i=e.split("."),o=i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+n),s=i[1]?a+i[1]:"";return o+s}if("function"==typeof Shopify.formatMoney)return Shopify.formatMoney(e,_config.moneyFormat);"string"==typeof e&&(e=e.replace(".",""));var n="",a=/\{\{\s*(\w+)\s*\}\}/,i=_config.moneyFormat;switch(i.match(a)[1]){case"amount":n=r(e,2);break;case"amount_no_decimals":n=r(e,0);break;case"amount_with_comma_separator":n=r(e,2,".",",");break;case"amount_no_decimals_with_comma_separator":n=r(e,0,".",",")}return i.replace(a,n)};return _init=function(){new Shopify.CountryProvinceSelector("address_country","address_province",{hideElement:"address_province_container"});var e=jQuery("#address_country"),t=jQuery("#address_province_label").get(0);"undefined"!=typeof Countries&&(Countries.updateProvinceLabel(e.val(),t),e.change(function(){Countries.updateProvinceLabel(e.val(),t)})),jQuery(".get-rates").click(function(){_disableButtons(),jQuery("#"+_config.wrapperId).empty().hide();var e={};e.zip=jQuery("#address_zip").val()||"",e.country=jQuery("#address_country").val()||"",e.province=jQuery("#address_province").val()||"",_getCartShippingRatesForDestination(e)}),_config.customerIsLoggedIn&&jQuery(".get-rates:eq(0)").trigger("click")},{show:function(e){e=e||{},jQuery.extend(_config,e),jQuery(function(){_init()})},getConfig:function(){return _config},formatRate:function(e){return _formatRate(e)}}}();
                    Shopify.Cart.ShippingCalculator.show( {
                      submitButton: theme.strings.shippingCalcSubmitButton,
                      submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
                      customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
                      moneyFormat: theme.strings.shippingCalcMoneyFormat
                    });
                }  
            }, 1000);
        },
    }
})(jQuery);

/* ============================================================================
   DN CUSTOM v22 — TIER 2 / TIER 3 AUTOMATIC REWARD PRODUCTS
   Standalone and additive. It does not replace the original Vinova cart code.
   ============================================================================ */
(function (window, document, $) {
  'use strict';

  if (window.__VINOVA_TIER_REWARDS_V22__) return;
  window.__VINOVA_TIER_REWARDS_V22__ = true;

  /* DN CUSTOM v25 — LEGACY REWARD ENGINE DISABLED:
     This legacy v22 reward engine must not bind alongside assets/vinova-cart-pro.js.
     assets/vinova-cart-pro.js is the single source of truth and keeps only the highest
     eligible gift: Tier 2 at Tier 2, then Tier 3 only after Tier 3 is reached.
     Returning here prevents v22 from re-adding the Tier 2 gift after v25 removes it. */
  return;

  var CONFIG_SELECTOR = '[data-cartui-auto-reward-config]';
  var CART_HOST = '#cart-info';
  var STATE_KEY = 'vinova_cartui_tier_reward_state_v22';
  var scheduleTimer = null;
  var syncing = false;
  var queued = false;
  var observer = null;
  var celebrationTimer = null;

  function route(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + String(path || '').replace(/^\//, '');
  }

  function toBool(value) {
    return String(value).toLowerCase() === 'true';
  }

  function toInt(value, fallback) {
    var parsed = parseInt(value, 10);
    return isNaN(parsed) ? (fallback || 0) : parsed;
  }

  function getConfig() {
    var el = document.querySelector(CONFIG_SELECTOR);
    if (!el) return null;

    var config = {
      enabled: toBool(el.getAttribute('data-enabled')),
      removeBelow: toBool(el.getAttribute('data-remove-below')),
      celebrationEnabled: toBool(el.getAttribute('data-celebration-enabled')),
      celebrationSeconds: Math.max(2, Math.min(10, toInt(el.getAttribute('data-celebration-seconds'), 5))),
      celebrationButton: el.getAttribute('data-celebration-button') || 'Continue Shopping',
      tiers: {
        2: {
          enabled: toBool(el.getAttribute('data-tier2-enabled')),
          threshold: toInt(el.getAttribute('data-tier2-threshold'), 0),
          variantId: toInt(el.getAttribute('data-tier2-variant-id'), 0),
          productTitle: el.getAttribute('data-tier2-product-title') || '',
          popupTitle: el.getAttribute('data-tier2-popup-title') || 'Tier 2 unlocked!',
          popupText: el.getAttribute('data-tier2-popup-text') || 'Your Tier 2 reward has been added to the cart.'
        },
        3: {
          enabled: toBool(el.getAttribute('data-tier3-enabled')),
          threshold: toInt(el.getAttribute('data-tier3-threshold'), 0),
          variantId: toInt(el.getAttribute('data-tier3-variant-id'), 0),
          productTitle: el.getAttribute('data-tier3-product-title') || '',
          popupTitle: el.getAttribute('data-tier3-popup-title') || 'Tier 3 unlocked!',
          popupText: el.getAttribute('data-tier3-popup-text') || 'Your Tier 3 reward has been added to the cart.'
        }
      }
    };

    config.signature = [
      config.tiers[2].threshold,
      config.tiers[2].variantId,
      config.tiers[3].threshold,
      config.tiers[3].variantId
    ].join(':');

    return config;
  }

  function getState(config) {
    var fallback = { signature: config.signature, tier2: false, tier3: false };
    try {
      var parsed = JSON.parse(window.sessionStorage.getItem(STATE_KEY) || 'null');
      if (!parsed || parsed.signature !== config.signature) return fallback;
      return {
        signature: config.signature,
        tier2: !!parsed.tier2,
        tier3: !!parsed.tier3
      };
    } catch (error) {
      return fallback;
    }
  }

  function setState(config, tier2, tier3) {
    try {
      window.sessionStorage.setItem(STATE_KEY, JSON.stringify({
        signature: config.signature,
        tier2: !!tier2,
        tier3: !!tier3
      }));
    } catch (error) {}
  }

  function requestJSON(path, options) {
    options = options || {};
    options.credentials = 'same-origin';
    options.headers = options.headers || {};
    options.headers.Accept = 'application/json';
    if (options.body && !options.headers['Content-Type']) {
      options.headers['Content-Type'] = 'application/json';
    }

    return window.fetch(route(path), options).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          var message = (data && (data.description || data.message)) || 'Cart request failed.';
          throw new Error(message);
        }
        return data;
      });
    });
  }

  function getCart() {
    return requestJSON('cart.js', { method: 'GET' });
  }

  function changeLine(key, quantity) {
    return requestJSON('cart/change.js', {
      method: 'POST',
      body: JSON.stringify({ id: key, quantity: quantity })
    });
  }

  function addRewardItems(items) {
    if (!items.length) return Promise.resolve(null);
    return requestJSON('cart/add.js', {
      method: 'POST',
      body: JSON.stringify({ items: items })
    });
  }

  function isAutoReward(item) {
    return !!(item && item.properties && String(item.properties._cartui_auto_reward) === 'true');
  }

  function rewardTier(item) {
    if (!isAutoReward(item)) return 0;
    return toInt(item.properties._cartui_reward_tier, 0);
  }

  function qualifyingSubtotal(cart) {
    return (cart.items || []).reduce(function (total, item) {
      if (isAutoReward(item)) return total;
      return total + toInt(item.final_line_price, 0);
    }, 0);
  }

  function addChangeOperation(list, key, quantity) {
    if (!key) return;
    list.push({ key: key, quantity: quantity });
  }

  function buildPlan(cart, config) {
    var subtotal = qualifyingSubtotal(cart);
    var changes = [];
    var additions = [];
    var eligibility = { 2: false, 3: false };

    [2, 3].forEach(function (tierNumber) {
      var tier = config.tiers[tierNumber];
      var featureAvailable = !!(
        config.enabled &&
        tier.enabled &&
        tier.variantId > 0 &&
        tier.threshold > 0
      );
      var eligible = featureAvailable && subtotal >= tier.threshold;
      eligibility[tierNumber] = eligible;

      var tierLines = (cart.items || []).filter(function (item) {
        return rewardTier(item) === tierNumber;
      });

      if (!eligible) {
        /* Always remove stale rewards when the feature/product is disabled.
           The setting only controls removal caused by dropping below threshold. */
        if (!featureAvailable || config.removeBelow) {
          tierLines.forEach(function (item) {
            addChangeOperation(changes, item.key, 0);
          });
        }
        return;
      }

      var matchingLine = null;
      tierLines.forEach(function (item) {
        if (!matchingLine && toInt(item.id, 0) === tier.variantId) {
          matchingLine = item;
        } else {
          addChangeOperation(changes, item.key, 0);
        }
      });

      if (!matchingLine) {
        additions.push({
          id: tier.variantId,
          quantity: 1,
          properties: {
            _cartui_auto_reward: 'true',
            _cartui_reward_tier: String(tierNumber)
          }
        });
      } else if (toInt(matchingLine.quantity, 0) !== 1) {
        addChangeOperation(changes, matchingLine.key, 1);
      }
    });

    return {
      subtotal: subtotal,
      changes: changes,
      additions: additions,
      eligibility: eligibility,
      mutated: changes.length > 0 || additions.length > 0
    };
  }

  function runChangesSequentially(changes) {
    return changes.reduce(function (promise, operation) {
      return promise.then(function () {
        return changeLine(operation.key, operation.quantity);
      });
    }, Promise.resolve());
  }

  function updateHeaderCart(cart) {
    if (!cart) return;
    var countEls = document.querySelectorAll('#CartCount, #CartCountCavas');
    Array.prototype.forEach.call(countEls, function (el) {
      el.textContent = cart.item_count;
    });

    var total = document.querySelector('#cart_total');
    if (total && window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
      total.innerHTML = window.Shopify.formatMoney(cart.total_price, window.theme.moneyFormat);
    }
  }

  function refreshDrawer(cart) {
    updateHeaderCart(cart);
    var host = document.querySelector(CART_HOST);
    if (!host) return Promise.resolve();

    if ($ && $.get) {
      return new Promise(function (resolve) {
        $.get(route('cart?view=json'), function (html) {
          $(host).html(html);
        }).always(resolve);
      });
    }

    return window.fetch(route('cart?view=json'), { credentials: 'same-origin' })
      .then(function (response) { return response.text(); })
      .then(function (html) { host.innerHTML = html; });
  }

  function removeCelebration() {
    if (celebrationTimer) {
      window.clearTimeout(celebrationTimer);
      celebrationTimer = null;
    }
    var existing = document.querySelector('.cu-reward-celebration');
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
  }

  function showCelebration(config, tierNumber) {
    if (!config.celebrationEnabled) return;
    var tier = config.tiers[tierNumber];
    if (!tier) return;

    removeCelebration();

    var popup = document.createElement('div');
    popup.className = 'cu-reward-celebration';
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    popup.setAttribute('aria-labelledby', 'cu-reward-celebration-title');

    var backdrop = document.createElement('div');
    backdrop.className = 'cu-reward-celebration__backdrop';
    backdrop.setAttribute('data-cu-reward-close', '');

    var card = document.createElement('div');
    card.className = 'cu-reward-celebration__card';

    var confetti = document.createElement('div');
    confetti.className = 'cu-reward-confetti';
    confetti.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < 12; i += 1) confetti.appendChild(document.createElement('i'));

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'cu-reward-celebration__close';
    close.setAttribute('aria-label', 'Close celebration');
    close.setAttribute('data-cu-reward-close', '');
    close.textContent = '×';

    var icon = document.createElement('div');
    icon.className = 'cu-reward-celebration__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '🎉';

    var title = document.createElement('h3');
    title.id = 'cu-reward-celebration-title';
    title.className = 'cu-reward-celebration__title';
    title.textContent = tier.popupTitle;

    var text = document.createElement('p');
    text.className = 'cu-reward-celebration__text';
    text.textContent = tier.popupText;

    if (tier.productTitle) {
      var product = document.createElement('span');
      product.className = 'cu-reward-celebration__product';
      product.textContent = tier.productTitle;
      text.appendChild(product);
    }

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'cu-reward-celebration__button';
    button.setAttribute('data-cu-reward-close', '');
    button.textContent = config.celebrationButton;

    card.appendChild(confetti);
    card.appendChild(close);
    card.appendChild(icon);
    card.appendChild(title);
    card.appendChild(text);
    card.appendChild(button);
    popup.appendChild(backdrop);
    popup.appendChild(card);
    document.body.appendChild(popup);

    window.setTimeout(function () { button.focus(); }, 50);
    celebrationTimer = window.setTimeout(removeCelebration, config.celebrationSeconds * 1000);
  }

  function chooseCelebration(previous, eligibility, config) {
    if (eligibility[3] && !previous.tier3 && config.tiers[3].variantId > 0) return 3;
    if (eligibility[2] && !previous.tier2 && config.tiers[2].variantId > 0) return 2;
    return 0;
  }

  function syncRewards() {
    var config = getConfig();
    if (!config) return Promise.resolve();

    if (syncing) {
      queued = true;
      return Promise.resolve();
    }

    syncing = true;
    queued = false;

    var previous = getState(config);
    var plan = null;
    var finalCart = null;

    return getCart()
      .then(function (cart) {
        plan = buildPlan(cart, config);
        var celebrationTier = chooseCelebration(previous, plan.eligibility, config);
        plan.celebrationTier = celebrationTier;

        return runChangesSequentially(plan.changes)
          .then(function () { return addRewardItems(plan.additions); })
          .then(function () { return plan.mutated ? getCart() : cart; });
      })
      .then(function (cart) {
        finalCart = cart;
        setState(config, plan.eligibility[2], plan.eligibility[3]);
        if (!plan.mutated) {
          updateHeaderCart(cart);
          return null;
        }
        return refreshDrawer(cart);
      })
      .then(function () {
        if (plan && plan.celebrationTier) showCelebration(config, plan.celebrationTier);
      })
      .catch(function (error) {
        if (window.console && console.error) {
          console.error('Vinova tier reward sync:', error);
        }
      })
      .then(function () {
        syncing = false;
        if (queued) scheduleSync(60);
        return finalCart;
      });
  }

  function scheduleSync(delay) {
    if (scheduleTimer) window.clearTimeout(scheduleTimer);
    scheduleTimer = window.setTimeout(function () {
      scheduleTimer = null;
      syncRewards();
    }, typeof delay === 'number' ? delay : 120);
  }

  function observeCart() {
    var host = document.querySelector(CART_HOST);
    if (!host || !window.MutationObserver) return;
    if (observer) observer.disconnect();
    observer = new MutationObserver(function () {
      scheduleSync(140);
    });
    observer.observe(host, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (event) {
    var close = event.target && event.target.closest ? event.target.closest('[data-cu-reward-close]') : null;
    if (close) {
      event.preventDefault();
      removeCelebration();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && document.querySelector('.cu-reward-celebration')) {
      removeCelebration();
    }
  });

  if ($ && $.fn && $.ajax) {
    $(document).ajaxComplete(function (_event, _xhr, settings) {
      var url = settings && settings.url ? String(settings.url) : '';
      if (/\/cart\/(add|change|update|clear)\.js(?:\?|$)/.test(url)) {
        scheduleSync(90);
      }
      if (/\/cart(?:\?|$)/.test(url)) observeCart();
    });
  }

  document.addEventListener('cart:updated', function () { scheduleSync(60); });
  document.addEventListener('cart:refresh', function () { scheduleSync(60); });
  window.addEventListener('pageshow', function () { scheduleSync(80); });

  function initTierRewards() {
    observeCart();
    scheduleSync(80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTierRewards);
  } else {
    initTierRewards();
  }

  window.VinovaTierRewards = {
    sync: syncRewards,
    schedule: scheduleSync,
    closeCelebration: removeCelebration
  };
})(window, document, window.jQuery);
/* =========================== END DN CUSTOM v22 =========================== */



/* DN CUSTOM v27 FAIL-SAFE CONTROLLER — appended so auto gifts run even without a separate include. */
/* =========================================================================
   DN CUSTOM v27 — vinova-cart-pro.js   (assets/vinova-cart-pro.js)
   Vinova cart drawer — single, self-sufficient controller.

   Replaces BOTH previous scripts:
     • the inline <script> that used to sit at the bottom of cart-ajax.liquid
       (scripts injected through the AJAX drawer do not reliably execute)
     • the DN CUSTOM v22 tier-reward IIFE in the main theme JS

   Sections
     A  helpers
     B  countdown (real timer + panel mirror)
     C  price details accordion
     D  offers panel open / close
     E  coupon engine — real Shopify discount, not a stored string
     F  tier reward engine — auto add / remove Tier 2 + Tier 3 products
     G  celebration popup
     H  delegation + wiring

   Load ONCE in theme.liquid before </body>:
     <script src="{{ 'vinova-cart-pro.js' | asset_url }}" defer></script>

   Nothing in the Vinova theme JS (nuranium.*) is touched or re-bound.
   ========================================================================= */
(function (window, document) {
  'use strict';

  if (window.__DN_CART_UI_V25__) {
    if (window.DNCartUI && window.DNCartUI.init) window.DNCartUI.init();
    return;
  }
  window.__DN_CART_UI_V25__ = true;

  /* the old v22 block exits on its own guard if it is still in the theme */
  window.__VINOVA_TIER_REWARDS_V22__ = true;
  window.__DN_CART_OFFERS_V10__ = true;

  /* Shared, first-come-first-served flag with the inline bootstrap in
     cart-ajax.liquid. Exactly one of the two binds the View Details /
     View All Offers toggles, so they can never double-fire and can never
     both be missing. */
  var OWNS_TOGGLES = !window.__DN_CART_TOGGLES__;
  if (OWNS_TOGGLES) window.__DN_CART_TOGGLES__ = 'asset';

  var $ = window.jQuery;

  var CART_HOST       = '#cart-info';
  var CONFIG_SELECTOR = '[data-cartui-auto-reward-config]';
  var STATE_KEY       = 'dn_cartui_tier_state_v26';
  var CLOCK_KEY       = 'dn_cartui_deadline_v26';
  var CODE_KEY        = 'vinova_cart_discount_code';
  var COMBO_KEY       = 'comboDiscountCode';
  var ANIM            = 260;

  var scheduleTimer = null;
  var syncing = false;
  var queued = false;
  var observer = null;
  var celebrationTimer = null;
  var mainClock = null;
  var failedTiers = {};

  /* =======================================================================
     A. HELPERS
     ======================================================================= */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function closest(el, sel) {
    if (!el) return null;
    if (el.nodeType !== 1) el = el.parentElement;
    return el && el.closest ? el.closest(sel) : null;
  }
  function cartRoot(from) { return (from && closest(from, CART_HOST)) || qs(CART_HOST); }
  function inCart(t) { return !!(t && closest(t, CART_HOST)); }
  function stop(e) {
    if (!e) return;
    if (e.cancelable !== false) e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
  }
  function route(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + String(path || '').replace(/^\//, '');
  }
  function toBool(v) { return String(v).toLowerCase() === 'true'; }
  function toInt(v, f) { var n = parseInt(v, 10); return isNaN(n) ? (f || 0) : n; }
  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, (window.theme && window.theme.moneyFormat) || '\u20B9{{amount}}');
    }
    return '\u20B9' + (toInt(cents, 0) / 100).toFixed(2);
  }
  function requestJSON(path, options) {
    options = options || {};
    options.credentials = 'same-origin';
    options.headers = options.headers || {};
    options.headers.Accept = 'application/json';
    if (options.body && !options.headers['Content-Type']) options.headers['Content-Type'] = 'application/json';
    return window.fetch(route(path), options).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error((data && (data.description || data.message)) || 'Cart request failed.');
        return data;
      });
    });
  }
  function getCart() { return requestJSON('cart.js', { method: 'GET' }); }

  function updateHeaderCart(cart) {
    if (!cart) return;
    qsa('#CartCount, #CartCountCavas').forEach(function (el) { el.textContent = cart.item_count; });
    var total = qs('#cart_total');
    if (total && window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
      total.innerHTML = window.Shopify.formatMoney(cart.total_price, window.theme.moneyFormat);
    }
  }
  function refreshDrawer(cart) {
    updateHeaderCart(cart);
    var host = qs(CART_HOST);
    if (!host) return Promise.resolve();
    if ($ && $.get) {
      return new Promise(function (resolve) {
        $.get(route('cart?view=json'), function (html) { $(host).html(html); }).always(resolve);
      });
    }
    return window.fetch(route('cart?view=json'), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) { host.innerHTML = html; });
  }

  /* =======================================================================
     B. COUNTDOWN — a real timer, persisted so it survives drawer re-renders
     ======================================================================= */
  function paintClock(minEl, secEl, total) {
    if (total < 0) total = 0;
    var mm = Math.floor(total / 60), ss = total % 60;
    if (minEl) minEl.textContent = mm + 'm';
    if (secEl) secEl.textContent = (ss < 10 ? '0' + ss : '' + ss) + 's';
  }
  function getDeadline(minutes) {
    var now = Date.now();
    try {
      var stored = JSON.parse(window.sessionStorage.getItem(CLOCK_KEY) || 'null');
      if (stored && toInt(stored.minutes, 0) === minutes && toInt(stored.deadline, 0) > now) {
        return toInt(stored.deadline, 0);
      }
    } catch (err) {}
    var next = now + (minutes * 60 * 1000);
    try {
      window.sessionStorage.setItem(CLOCK_KEY, JSON.stringify({ minutes: minutes, deadline: next }));
    } catch (err) {}
    return next;
  }
  function startClock() {
    if (mainClock) { window.clearInterval(mainClock); mainClock = null; }
    var root = qs(CART_HOST);
    if (!root) return;
    var box = qs('[data-cartui-countdown]', root);
    if (!box) return;

    var minutes = toInt(box.getAttribute('data-minutes'), 10) || 10;
    var deadline = getDeadline(minutes);

    function tick() {
      var host = qs(CART_HOST);
      if (!host) { window.clearInterval(mainClock); mainClock = null; return; }
      var left = Math.round((deadline - Date.now()) / 1000);
      if (left <= 0) {
        left = minutes * 60;
        deadline = Date.now() + (left * 1000);
        try { window.sessionStorage.setItem(CLOCK_KEY, JSON.stringify({ minutes: minutes, deadline: deadline })); } catch (err) {}
      }
      paintClock(qs('[data-cartui-min]', host), qs('[data-cartui-sec]', host), left);
      /* mirror into the offers panel */
      paintClock(qs('[data-cu-min]', host), qs('[data-cu-sec]', host), left);
    }
    tick();
    mainClock = window.setInterval(tick, 1000);
  }

  /* =======================================================================
     C. PRICE DETAILS ACCORDION
     ======================================================================= */
  function getDetails(root) { return qs('[data-cartui-details-panel], .cu-details-inline', root || document); }
  function getDrawer(root) {
    return (root && root.classList && root.classList.contains('cu-drawer')) ? root :
           (root && qs('.cu-drawer', root)) || closest(root, '.cu-drawer') || qs('.cu-drawer') || root;
  }
  function outerH(el) {
    if (!el) return 0;
    var h = el.offsetHeight || 0;
    try {
      var cs = window.getComputedStyle(el);
      h += (parseFloat(cs.marginTop) || 0) + (parseFloat(cs.marginBottom) || 0);
    } catch (err) {}
    return h;
  }
  function fitDetailsPanel(root, panel) {
    root = cartRoot(root) || root || qs(CART_HOST);
    panel = panel || getDetails(root);
    if (!root || !panel) return;

    var drawer = getDrawer(root);
    var bottom = closest(panel, '.cu-bottom') || qs('.cu-bottom', root);
    var top = qs('.cu-top', root);
    var viewRow = bottom ? qs('.cu-view-row', bottom) : null;
    var savedBar = bottom ? qs('.cu-saved-banner', bottom) : null;
    var checkout = bottom ? qs('.cu-checkout', bottom) : null;

    var drawerH = (drawer && drawer.clientHeight) || window.innerHeight || document.documentElement.clientHeight || 0;
    var topH = top ? top.offsetHeight : 0;
    var padT = 22, padB = 54;
    if (bottom && window.getComputedStyle) {
      var bcs = window.getComputedStyle(bottom);
      padT = parseFloat(bcs.paddingTop) || padT;
      padB = parseFloat(bcs.paddingBottom) || padB;
    }
    var fixedH = padT + padB + outerH(viewRow) + outerH(savedBar) + outerH(checkout) + 24;
    var available = Math.max(180, drawerH - topH - 8);
    var maxPanel = Math.floor(available - fixedH);
    /* checkout visibility wins; the panel scrolls inside this height */
    maxPanel = Math.max(92, Math.min(maxPanel, 285));
    panel.style.setProperty('--cu-details-max', maxPanel + 'px');
  }
  function setDetailsState(root, open) {
    root = cartRoot(root) || root || qs(CART_HOST);
    if (!root) return false;
    var panel = getDetails(root);
    if (!panel) return false;

    if (open) {
      fitDetailsPanel(root, panel);
      panel.setAttribute('aria-hidden', 'false');
      window.requestAnimationFrame(function () {
        fitDetailsPanel(root, panel);
        panel.classList.add('is-open');
      });
    } else {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      panel.style.removeProperty('--cu-details-max');
    }
    qsa('[data-cartui-details]', root).forEach(function (t) {
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    return false;
  }
  function toggleDetails(btn) {
    var root = cartRoot(btn);
    if (!root) return false;
    var panel = getDetails(root);
    if (!panel) return false;
    return setDetailsState(root, !panel.classList.contains('is-open'));
  }

  /* =======================================================================
     D. OFFERS PANEL
     ======================================================================= */
  function getPanel(root) {
    return qs('[data-cu-offers-panel], [data-cartui-panel="offers"], .cu-offers-panel', root || document);
  }
  function openOffers(from) {
    var root = cartRoot(from);
    if (!root) return false;
    var panel = getPanel(root);
    if (!panel) { if (window.console) console.warn('[DN Cart v26] offers panel not found.'); return false; }
    panel.removeAttribute('hidden');
    panel.setAttribute('aria-hidden', 'false');
    window.requestAnimationFrame(function () {
      panel.classList.add('is-open');
      syncInputs(panel);
    });
    return false;
  }
  function closeOffers(from) {
    var root = cartRoot(from);
    if (!root) return false;
    var panel = getPanel(root);
    if (!panel) return false;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    window.setTimeout(function () { panel.setAttribute('hidden', 'hidden'); }, ANIM);
    return false;
  }
  function toggleMore(btn) {
    var item = closest(btn, '.cu-payoffer');
    var details = item ? qs('.cu-pay-details, [data-cu-pay-details]', item) : null;
    if (!details) return false;
    var open = details.hasAttribute('hidden') || !details.classList.contains('is-open');
    if (open) { details.removeAttribute('hidden'); details.classList.add('is-open'); }
    else { details.setAttribute('hidden', 'hidden'); details.classList.remove('is-open'); }
    btn.textContent = open ? 'Show Less' : 'Show More';
    return false;
  }

  /* =======================================================================
     E. COUPON ENGINE
     ----------------------------------------------------------------------
     /discount/CODE?redirect=/cart.js puts the code on the cart session server
     side, so cart.cart_level_discount_applications is populated and the Liquid
     Price Details block can print a real coupon value on the next render.
     ======================================================================= */
  function setMessage(text, type) {
    qsa('[data-dn-offer-msg]').forEach(function (box) {
      box.hidden = !text;
      box.textContent = text || '';
      box.classList.remove('is-success', 'is-error', 'is-info');
      if (text) box.classList.add(type || 'is-info');
    });
    qsa('[data-cu-discount-message], [data-cartui-discount-message]').forEach(function (el) {
      el.hidden = !text;
      el.textContent = text || '';
      el.classList.remove('is-success', 'is-error');
      if (text) el.classList.add(type === 'is-error' ? 'is-error' : 'is-success');
    });
  }
  function getCode() {
    try {
      return (window.localStorage.getItem(CODE_KEY) || window.localStorage.getItem(COMBO_KEY) || '').trim();
    } catch (err) { return ''; }
  }
  function rememberCode(code) {
    try {
      window.localStorage.setItem(CODE_KEY, code);
      window.localStorage.setItem(COMBO_KEY, code);
    } catch (err) {}
  }
  function syncInputs(root, code) {
    root = root || qs(CART_HOST) || document;
    code = code || getCode();
    if (!code) return;
    qsa('[data-dn-coupon-input], [data-cu-discount-input], #discount-code-input, input[name="discount"]', root)
      .forEach(function (input) {
        if (input && input.tagName === 'INPUT' && !input.value) input.value = code;
      });
  }
  function codeIsApplied(cart, code) {
    var wanted = String(code || '').toUpperCase();
    var apps = [].concat(
      (cart && cart.discount_applications) || [],
      (cart && cart.cart_level_discount_applications) || []
    );
    return apps.some(function (a) {
      return String(a.title || a.code || '').toUpperCase() === wanted;
    });
  }
  function applyDiscountCode(code, btn) {
    code = String(code || '').trim().toUpperCase();
    if (!code) {
      setMessage('Please enter a coupon code.', 'is-error');
      return Promise.resolve(false);
    }

    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'APPLYING'; }
    setMessage('Applying ' + code + '\u2026', 'is-info');

    return window.fetch(route('discount/' + encodeURIComponent(code) + '?redirect=/cart.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) { return res.json().catch(function () { return null; }); })
      .then(function (cart) { return (cart && cart.items) ? cart : getCart(); })
      .then(function (cart) {
        rememberCode(code);
        var applied = codeIsApplied(cart, code);

        if (applied) {
          setMessage('Coupon ' + code + ' applied.', 'is-success');
          if (btn) { btn.classList.add('is-applied'); btn.textContent = 'APPLIED'; }
        } else {
          /* code accepted but order-level / line-level only, or not valid here */
          setMessage('Coupon ' + code + ' saved. If it is valid it will apply at checkout.', 'is-info');
          if (btn) btn.textContent = label || 'APPLY';
        }

        qsa('[data-dn-coupon-input], [data-cu-discount-input]').forEach(function (i) {
          if (i && i.tagName === 'INPUT') i.value = code;
        });

        return refreshDrawer(cart).then(function () { return applied; });
      })
      .catch(function (err) {
        if (window.console) console.warn('[DN Cart v26] coupon apply:', err);
        setMessage('Could not apply ' + code + '. Please check the code and try again.', 'is-error');
        return false;
      })
      .then(function (result) {
        if (btn) { btn.disabled = false; if (!btn.classList.contains('is-applied')) btn.textContent = label || 'APPLY'; }
        return result;
      });
  }
  function checkoutWithDiscount(e, btn) {
    var input = qs('[data-dn-coupon-input], [data-cu-discount-input], #discount-code-input', cartRoot(btn) || document);
    var code = (input && input.value.trim()) || getCode();
    if (!code) return false;
    stop(e);
    rememberCode(code);
    window.location.href = route('discount/' + encodeURIComponent(code) + '?redirect=/checkout');
    return true;
  }

  /* =======================================================================
     F. TIER REWARD ENGINE
     ======================================================================= */
  function getConfig() {
    var el = qs(CONFIG_SELECTOR);
    if (!el) {
      if (!window.__DN_CART_CONFIG_WARNED__ && window.console) {
        window.__DN_CART_CONFIG_WARNED__ = true;
        console.warn('[DN Cart v26] Missing [data-cartui-auto-reward-config] in cart-ajax.liquid. ' +
                     'Automatic tier rewards cannot run without it.');
      }
      return null;
    }
    var cfg = {
      enabled:            toBool(el.getAttribute('data-enabled')),
      removeBelow:        toBool(el.getAttribute('data-remove-below')),
      celebrationEnabled: toBool(el.getAttribute('data-celebration-enabled')),
      celebrationSeconds: Math.max(2, Math.min(10, toInt(el.getAttribute('data-celebration-seconds'), 5))),
      celebrationButton:  el.getAttribute('data-celebration-button') || 'Continue Shopping',
      badgeText:          el.getAttribute('data-badge-text') || 'Free Gift',
      tiers: {}
    };
    [2, 3].forEach(function (n) {
      cfg.tiers[n] = {
        enabled:      toBool(el.getAttribute('data-tier' + n + '-enabled')),
        threshold:    toInt(el.getAttribute('data-tier' + n + '-threshold'), 0),
        variantId:    toInt(el.getAttribute('data-tier' + n + '-variant-id'), 0),
        productTitle: el.getAttribute('data-tier' + n + '-product-title') || '',
        worth:        toInt(el.getAttribute('data-tier' + n + '-worth'), 0),
        popupTitle:   el.getAttribute('data-tier' + n + '-popup-title') || ('Tier ' + n + ' unlocked!'),
        popupText:    el.getAttribute('data-tier' + n + '-popup-text') || 'Your reward has been added to the cart.'
      };
    });
    cfg.signature = [cfg.tiers[2].threshold, cfg.tiers[2].variantId,
                     cfg.tiers[3].threshold, cfg.tiers[3].variantId].join(':');
    return cfg;
  }
  function getState(cfg) {
    var fallback = { signature: cfg.signature, tier2: false, tier3: false };
    try {
      var p = JSON.parse(window.sessionStorage.getItem(STATE_KEY) || 'null');
      if (!p || p.signature !== cfg.signature) return fallback;
      return { signature: cfg.signature, tier2: !!p.tier2, tier3: !!p.tier3 };
    } catch (err) { return fallback; }
  }
  function setState(cfg, t2, t3) {
    try {
      window.sessionStorage.setItem(STATE_KEY, JSON.stringify({ signature: cfg.signature, tier2: !!t2, tier3: !!t3 }));
    } catch (err) {}
  }
  function isAutoReward(item) {
    return !!(item && item.properties && String(item.properties._cartui_auto_reward) === 'true');
  }
  function rewardTier(item) {
    return isAutoReward(item) ? toInt(item.properties._cartui_reward_tier, 0) : 0;
  }
  /* gift lines must never count toward the threshold that unlocked them */
  function qualifyingSubtotal(cart) {
    return (cart.items || []).reduce(function (t, item) {
      return isAutoReward(item) ? t : t + toInt(item.final_line_price, 0);
    }, 0);
  }
  function buildPlan(cart, cfg) {
    var subtotal = qualifyingSubtotal(cart);
    var changes = [], additions = [], eligibility = { 2: false, 3: false };

    function usable(n) {
      var tier = cfg.tiers[n];
      return !!(cfg.enabled && tier.enabled && tier.variantId > 0 && tier.threshold > 0 && !failedTiers[n]);
    }

    eligibility[2] = usable(2) && subtotal >= cfg.tiers[2].threshold;
    eligibility[3] = usable(3) && subtotal >= cfg.tiers[3].threshold;

    /* Only the highest unlocked reward may exist in the cart.
       Tier 2 is active from Tier 2 threshold until Tier 3 threshold.
       Once Tier 3 is reached, Tier 2 is removed and only Tier 3 remains. */
    var activeTier = eligibility[3] ? 3 : (eligibility[2] ? 2 : 0);

    [2, 3].forEach(function (n) {
      var tier = cfg.tiers[n];
      var lines = (cart.items || []).filter(function (i) { return rewardTier(i) === n; });
      var shouldExist = activeTier === n;

      if (!shouldExist) {
        /* Tier replacement is always enforced. Dropping below all reward tiers
           follows the existing remove-below setting. Disabled or invalid rewards
           are always cleaned up. */
        var mustRemove = activeTier > 0 || !usable(n) || cfg.removeBelow;
        if (mustRemove) lines.forEach(function (i) { changes.push({ key: i.key, quantity: 0 }); });
        return;
      }

      var match = null;
      lines.forEach(function (i) {
        if (!match && toInt(i.id, 0) === tier.variantId) match = i;
        else changes.push({ key: i.key, quantity: 0 });
      });

      if (!match) {
        additions.push({
          id: tier.variantId,
          quantity: 1,
          properties: { _cartui_auto_reward: 'true', _cartui_reward_tier: String(n) }
        });
      } else if (toInt(match.quantity, 0) !== 1) {
        changes.push({ key: match.key, quantity: 1 });
      }
    });

    return {
      subtotal: subtotal, activeTier: activeTier, changes: changes, additions: additions, eligibility: eligibility,
      mutated: changes.length > 0 || additions.length > 0
    };
  }
  function runChanges(changes) {
    return changes.reduce(function (p, op) {
      return p.then(function () {
        return requestJSON('cart/change.js', { method: 'POST', body: JSON.stringify({ id: op.key, quantity: op.quantity }) });
      });
    }, Promise.resolve());
  }
  function addRewardItems(items) {
    if (!items.length) return Promise.resolve(null);
    return requestJSON('cart/add.js', { method: 'POST', body: JSON.stringify({ items: items }) });
  }
  function chooseCelebration(prev, eligibility, cfg) {
    if (eligibility[3] && !prev.tier3 && cfg.tiers[3].variantId > 0) return 3;
    if (eligibility[2] && !prev.tier2 && cfg.tiers[2].variantId > 0) return 2;
    return 0;
  }
  function syncRewards() {
    var cfg = getConfig();
    if (!cfg) return Promise.resolve();
    if (syncing) { queued = true; return Promise.resolve(); }
    syncing = true; queued = false;

    var prev = getState(cfg), plan = null, finalCart = null;

    return getCart()
      .then(function (cart) {
        plan = buildPlan(cart, cfg);
        plan.celebrationTier = chooseCelebration(prev, plan.eligibility, cfg);
        return runChanges(plan.changes)
          .then(function () { return addRewardItems(plan.additions); })
          .catch(function (err) {
            /* variant sold out or unavailable — stop hammering the API */
            plan.additions.forEach(function (add) {
              [2, 3].forEach(function (n) { if (cfg.tiers[n].variantId === add.id) failedTiers[n] = true; });
            });
            plan.celebrationTier = 0;
            if (window.console) console.warn('[DN Cart v26] reward product could not be added:', err.message);
          })
          .then(function () { return plan.mutated ? getCart() : cart; });
      })
      .then(function (cart) {
        finalCart = cart;
        setState(cfg, plan.eligibility[2], plan.eligibility[3]);
        if (!plan.mutated) { updateHeaderCart(cart); return null; }
        return refreshDrawer(cart);
      })
      .then(function () {
        if (plan && plan.celebrationTier) showCelebration(cfg, plan.celebrationTier);
      })
      .catch(function (err) {
        if (window.console) console.error('[DN Cart v26] tier reward sync:', err);
      })
      .then(function () {
        syncing = false;
        if (queued) scheduleSync(60);
        return finalCart;
      });
  }
  function scheduleSync(delay) {
    if (scheduleTimer) window.clearTimeout(scheduleTimer);
    scheduleTimer = window.setTimeout(function () {
      scheduleTimer = null;
      syncRewards();
    }, typeof delay === 'number' ? delay : 120);
  }

  /* =======================================================================
     G. CELEBRATION POPUP
     ======================================================================= */
  function removeCelebration() {
    if (celebrationTimer) { window.clearTimeout(celebrationTimer); celebrationTimer = null; }
    var el = qs('.cu-reward-celebration');
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }
  function showCelebration(cfg, tierNumber) {
    if (!cfg.celebrationEnabled) return;
    var tier = cfg.tiers[tierNumber];
    if (!tier) return;
    removeCelebration();

    var popup = document.createElement('div');
    popup.className = 'cu-reward-celebration';
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    popup.setAttribute('aria-labelledby', 'cu-reward-celebration-title');

    var backdrop = document.createElement('div');
    backdrop.className = 'cu-reward-celebration__backdrop';
    backdrop.setAttribute('data-cu-reward-close', '');

    var card = document.createElement('div');
    card.className = 'cu-reward-celebration__card';

    var confetti = document.createElement('div');
    confetti.className = 'cu-reward-confetti';
    confetti.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < 12; i += 1) confetti.appendChild(document.createElement('i'));

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'cu-reward-celebration__close';
    close.setAttribute('aria-label', 'Close');
    close.setAttribute('data-cu-reward-close', '');
    close.innerHTML = '&times;';

    var icon = document.createElement('div');
    icon.className = 'cu-reward-celebration__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '\uD83C\uDF89';

    var title = document.createElement('h3');
    title.id = 'cu-reward-celebration-title';
    title.className = 'cu-reward-celebration__title';
    title.textContent = tier.popupTitle;

    var text = document.createElement('p');
    text.className = 'cu-reward-celebration__text';
    text.textContent = tier.popupText;

    if (tier.productTitle) {
      var product = document.createElement('span');
      product.className = 'cu-reward-celebration__product';
      product.textContent = tier.productTitle;
      text.appendChild(product);
    }
    if (tier.worth > 0) {
      var worth = document.createElement('span');
      worth.className = 'cu-reward-celebration__worth';
      worth.textContent = 'Worth ' + money(tier.worth);
      text.appendChild(worth);
    }

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'cu-reward-celebration__button';
    button.setAttribute('data-cu-reward-close', '');
    button.textContent = cfg.celebrationButton;

    card.appendChild(confetti);
    card.appendChild(close);
    card.appendChild(icon);
    card.appendChild(title);
    card.appendChild(text);
    card.appendChild(button);
    popup.appendChild(backdrop);
    popup.appendChild(card);
    document.body.appendChild(popup);

    window.setTimeout(function () { button.focus(); }, 50);
    celebrationTimer = window.setTimeout(removeCelebration, cfg.celebrationSeconds * 1000);
  }

  /* =======================================================================
     H. DELEGATION + WIRING
     ======================================================================= */
  function handleClick(e) {
    if (closest(e.target, '[data-cu-reward-close]')) { e.preventDefault(); removeCelebration(); return; }
    if (!inCart(e.target)) return;

    var checkout = closest(e.target, '.cu-checkout[name="checkout"], .cart__checkout[name="checkout"], button[name="checkout"]');
    if (checkout && checkoutWithDiscount(e, checkout)) return;

    if (OWNS_TOGGLES) {
      var detailsToggle = closest(e.target, '[data-cartui-details]');
      if (detailsToggle) { stop(e); toggleDetails(detailsToggle); return; }

      var openBtn = closest(e.target, '[data-cu-open-offers], [data-cartui-open="offers"], .cu-viewall');
      if (openBtn) { stop(e); openOffers(openBtn); return; }

      var closeBtn = closest(e.target, '.cu-op-close, [data-cu-close-offers], [data-cartui-panel-close], .cu-overlay-close, .cu-back');
      if (closeBtn && closest(closeBtn, '[data-cu-offers-panel], .cu-offers-panel')) { stop(e); closeOffers(closeBtn); return; }

      var moreBtn = closest(e.target, '[data-cu-more], [data-cartui-more], .cu-more');
      if (moreBtn && closest(moreBtn, '.cu-payoffer')) { stop(e); toggleMore(moreBtn); return; }
    }

    var rowBtn = closest(e.target, '[data-dn-apply-code]');
    if (rowBtn) { stop(e); applyDiscountCode(rowBtn.getAttribute('data-dn-apply-code'), rowBtn); return; }

    var fieldBtn = closest(e.target, '[data-dn-apply-field], [data-cu-apply-discount], .cu-coupon-apply, #save-discount-btn');
    if (fieldBtn) {
      stop(e);
      var box = closest(fieldBtn, '.cu-coupon') || cartRoot(fieldBtn);
      var input = box ? qs('[data-dn-coupon-input], [data-cu-discount-input], #discount-code-input, input[name="discount"]', box) : null;
      applyDiscountCode(input ? input.value : '', fieldBtn);
      return;
    }
  }
  function handleKeydown(e) {
    if (e.key === 'Escape' && qs('.cu-reward-celebration')) { removeCelebration(); return; }
    if (e.key !== 'Enter' || !inCart(e.target)) return;
    var input = closest(e.target, '[data-dn-coupon-input], [data-cu-discount-input], #discount-code-input, input[name="discount"]');
    if (!input) return;
    stop(e);
    var box = closest(input, '.cu-coupon');
    applyDiscountCode(input.value, box ? qs('[data-dn-apply-field], .cu-coupon-apply', box) : null);
  }
  function observeCart() {
    var host = qs(CART_HOST);
    if (!host || !window.MutationObserver) return;
    if (observer) observer.disconnect();
    observer = new MutationObserver(function () {
      startClock();
      syncInputs(host);
      scheduleSync(140);
    });
    observer.observe(host, { childList: true, subtree: false });
  }

  document.addEventListener('click', handleClick, true);
  document.addEventListener('keydown', handleKeydown, true);
  window.addEventListener('resize', function () {
    var root = qs(CART_HOST);
    var panel = root ? getDetails(root) : null;
    if (panel && panel.classList.contains('is-open')) fitDetailsPanel(root, panel);
  });

  if ($ && $.fn && $.ajax) {
    $(document).ajaxComplete(function (_e, _xhr, settings) {
      var url = settings && settings.url ? String(settings.url) : '';
      if (/\/cart\/(add|change|update|clear)\.js(?:\?|$)/.test(url)) scheduleSync(90);
      if (/\/cart(?:\?|$)/.test(url)) { observeCart(); startClock(); syncInputs(); }
    });
  }
  document.addEventListener('cart:updated', function () { scheduleSync(60); });
  document.addEventListener('cart:refresh', function () { scheduleSync(60); });
  window.addEventListener('pageshow', function () { scheduleSync(80); startClock(); });

  function init() {
    observeCart();
    startClock();
    syncInputs();
    scheduleSync(80);
    if (window.console) {
      console.log('[DN Cart v26] asset loaded. Toggles owned by: ' + (window.__DN_CART_TOGGLES__ || 'none'));
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* public API — handy from the console while testing */
  window.DNCartUI = {
    init: init,
    sync: syncRewards,
    schedule: scheduleSync,
    applyCode: applyDiscountCode,
    openOffers: function () { return openOffers(qs(CART_HOST)); },
    closeOffers: function () { return closeOffers(qs(CART_HOST)); },
    openDetails: function () { return setDetailsState(qs(CART_HOST), true); },
    closeDetails: function () { return setDetailsState(qs(CART_HOST), false); },
    closeCelebration: removeCelebration,
    resetFailedTiers: function () { failedTiers = {}; }
  };
  /* backward-compatible alias used by older theme code */
  window.VinovaCartOffers = window.DNCartUI;
  window.applyComboDiscount = function (code) { return applyDiscountCode(code); };
})(window, document);
/* ===================== END DN CUSTOM v27 ===================== */
